
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "公告详情":"공지사항",
  "未读":"읽히지 않는",
  "已读":"읽다",
  "主动取消":"활성 취소",
  "申请拒绝":"신청 거부",
  "赎回拒绝":"환매 거부",
  "重新申请":"다시 신청하세요",
  "撤回申请":"신청철회",
  "在这里购买有潜力的":"여기서 잠재력을 구매하세요",
    "什么是新币申购？":"신규코인 구독이란?",
    "投资价值高":"높은 투자 가치",
    "新币价格低，潜在价值高，适合投资":"새로운 화폐는 가격이 저렴하고 잠재적 가치가 높아 투자에 적합합니다.",
    "无手续费":"수수료 없음",
    "购买新币不需要任何手续费":"새로운 코인을 구매하는 데 수수료가 필요하지 않습니다.",
    "是交易产品中风险最低且收益稳定的一种投资方式":"거래상품 중에서 위험이 가장 낮고 수익률이 안정적인 투자방식입니다.",
    "产品":"제품",
    "我的申购订单":"내 구매 주문",
    "总数量":"총 수량",
    "已认购量":"구독 금액",
    "剩余数量":"남은 수량",
    "锁仓天数":"잠금 일",
    "浅色模式":"라이트 모드",
    "深色模式":"다크 모드",
  "修改昵称":"닉네임 변경",
  "昵称":"닉네임",
  "头像":"아바타",
  "绑定邮箱":"이메일 바인딩",
  "绑定手机号":"전화번호 바인딩",
  "未绑定":"미바인딩",
  "上传头像":"아바타 업로드",
  "修改头像":"아바타 변경",
  "个人信息":"개인정보",
  "我们发送了验证码至":"인증 코드를 보냈습니다",
  "中":"에",
  "请输入获取到的验证码以激活账户":"계정을 활성화하려면 인증 코드를 입력하세요",
    "请输入昵称":"별명을 입력해주세요",
    "手机号":"전화 번호",
    "邮箱号":"이메일 주소",
    "请输入邮箱号":"이메일 주소를 입력해주세요",
  "白皮书":"백",
  "驾驶证":"운전면허증",
  "居住证":"거주카드",
  "通过时间":"처리 시간",
  "银行账户":"은행 계좌",
    "请输入银行账户":"은행 계좌 번호를 입력하세요.",
    "银行国际代码":"SWIFT 코드",
    "请输入国际代码":"국제 코드를 입력하세요.",
    "电话号码":"전화번호",
    "请输入电话号码":"전화번호를 입력하세요.",
    "上传房屋证明":"주택 증빙 서류 업로드",
    "上传收入证明":"소득 증빙 서류 업로드",
    "上传银行证明":"은행 증빙 서류 업로드",
    "上传证件照":"신분증 사진 업로드",
    "提示:您可以通过上传证明来提高信用分":"팁: 증빙 서류를 업로드하면 신용 점수를 높일 수 있습니다.",
    "谷歌验证码":"Google 코드",
    "修改谷歌验证码":"Google 인증 코드 수정",
    "扫描二维码绑定":"QR 코드를 스캔하여 바인딩",
    "输入验证码":"인증 코드 입력",
    "你知道吗？":"알고 계셨나요?",
    "绑定2FA认证,提款时需要取得您的认证,资金更安全":"안전한 출금을 위해 2FA 바인딩",
    "立即绑定":"지금 바인딩",
    "请输入原绑定的谷歌验证码":"원래 Google 인증 코드 입력",
    "重新绑定":"다시 바인딩",
    "交易密码":"거래 비밀번호",
    "请输入交易密码":"비밀번호를 입력하세요",
    "请输入谷歌验证码":"Google 코드를 입력하세요",
    "请到安全中心设置交易密码":"보안센터에서 거래 비밀번호 설정",
    "请到安全中心设置谷歌验证":"보안 센터에서 Google 인증을 설정하세요",
    "请输入验证码":"코드를 입력하세요",
    "信用分":"신용점수",
  "关闭":"닫다",
  "查看详情":"세부 정보보기",
  "向卖家付款":"판매자에게 지불하기",
    "获取您的币种":"당신의 화폐를 얻으세요",
    "我的订单":"내 주문",
    "未匹配":"일치하지 않음",
    "已匹配":"일치",
    "已完成":"완료",
    "已过期":"만료됨",
      "合同号":"계약번호",
      "买入金额":"구매 금액",
      "邮箱":"우편",
      "请输入您的电子邮箱":"이메일 주소를 입력해주세요",
      "请选择购买的货币":"구매하고 싶은 통화를 선택해주세요.",
      "请选择支付的货币":"결제통화를 선택해주세요.",
      "请填写您的收款信息，如有需要补充信息请填写到备注栏或者联系客服。":"결제 정보를 입력해 주세요. 추가 정보가 필요하면 비고란에 입력하거나 고객센터로 문의해 주세요.",
      "备注":"주목",
      "请选择币种":"통화를 선택해주세요",
      "请输入钱包地址":"지갑 주소를 입력해주세요..",
      "绑定钱包":"지갑을 묶다",
      "钱包地址":"지갑 주소",
      "请输入备注":"댓글을 입력해주세요",
      "提现地址":"출금 주소",
      "添加钱包地址":"지갑 주소 추가",
      "钱包管理":"지갑 관리",
    "重要提示：":"중요한 팁:",
    "订单有效期：买方或卖方需在发起订单后3小时内完成交易。如未能完成，请及时联系在线客服确认订单状态。":"주문 유효 기간: 구매자 또는 판매자는 주문을 시작한 후 3시간 이내에 거래를 완료해야 합니다. 완료되지 않을 경우, 주문 상태를 확인하기 위해 온라인 고객 서비스에 제때 연락해 주시기 바랍니다.",
    "订单失效：若未在规定时间内联系客服，订单将自动失效，无法恢复。":"주문 만료: 지정된 시간 내에 고객센터에 연락하지 않을 경우, 주문은 자동으로 만료되며 복구할 수 없습니다.",
    "安全保障：我们提供全面的交易保障措施，确保您的资金和交易信息安全。":"보안: 우리는 귀하의 자금과 거래 정보의 안전을 보장하기 위해 포괄적인 거래 보호 조치를 제공합니다.",

    "充值":"보증금",
    "提现":"철회하다",
    "兑换":"교환",
    "今日收益":"손익(오늘)",
    "现金":"현금",
    "交易":"거래",
    "理财":"재무 관리",
    "资产列表":"자산 목록",
  "已锁仓":"잠김",
  "最高可贷款":"최대 대출 가능 금액",
  "请先完成高级认证":"사전 확인을 완료해 주세요",
  "贷款金额":"대출 금액",
  "总还款额":"총 상환액",
  "金融":"재원",
  "选择周期":"사이클 선택",
  "选择类型":"유형 선택",
  "结算价":"결제 가격",
  "限价卖出":"판매 한도",
  "截止价卖出":"판매 정지",
  "加密货币":"암호화폐",
  "银行卡":"은행 카드",
  "金额":"양",
  "选择银行":"은행 선택",
  "提款需要的手续费,这需要由网络节点确认, 才能记入请不要将加密货币转让给陌生人":"출금 수수료는 적립되기 전에 네트워크 노드에서 확인해야 합니다. 낯선 사람에게 암호화폐를 전송하지 마십시오.",
  "银行卡管理":"은행 계좌 관리",
  "绑定银行卡":"은행 카드 연결",
  "添加":"추가하다",
  "添加银行卡":"은행카드 추가",
  "修改银行卡":"은행카드 수정",
  "请添加银行卡":"은행카드를 추가해주세요",
  "数量":"수량",
  "继续下单":"계속하다",
  "路由号码":"라우팅 번호",
  "请输入路由号码":"라우팅 번호를 입력하세요",
  "搜索":"찾다",

  "限价买入":"제한 매수",
  "截止价买入":"정지 가격 매수",
  "限价卖出":"판매 한도",
  "截止价卖出":"판매 정지",
  "贷款金额":"대출 금액",
  "总还款额":"총 상환액",
  "委托总量":"위탁총액",
  "交易总额":"총 거래 금액",
  "成交价格":"거래가격",
  "委托价格":"수수료 가격",
  "顶尖交易技术":"상단교차기술",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"우리는 당신의 제품을 좋아합니다!",
  "累计收入":"누적수익",
    "每日收益":"일일 수입",
    "助您探索更多交易机会和":"더 많은 거래 기회를 탐색하는 데 도움이 됩니다.",
    "金融产品":"금융 상품",
    "什么是活期借贷？":"수요 대출이란?",
    "累计利息":"누적이자",
    "申请金额":"신청금액",
  "风险":"리스크",
  "审核结果":"심사 결과",
  "您的等级为":"귀하의 등급은",
  "未评估":"미평가",
  "谨慎性":"신중형",
  "稳健型":"안정형",
  "进取型":"공격형",
  "提示：您的风险承受为谨慎型，最高投资额为":"안내: 귀하의 리스크 감내 수준은 신중형이며, 최대 투자 금액은",
  "如果您想提高额度请重新评估或联系客服":"한도를 높이고 싶으시면 재평가를 진행하거나 고객센터에 문의하세요",
  "重新评估":"재평가",
  "验证中,请耐心等待系统审核":"검증 중입니다. 시스템 심사를 기다려 주십시오",
  "确保符合平台的合规要求并完成您的投资者资格认证,我们需要您提供以下信息,请放心,您提供的所有资料将储存在我们高度加密和安全的资料库中,完全符合国际安全标准。我们非常重视您的资讯隐私,未经您的明确同意,绝不外泄或者分享这些资料":"플랫폼의 준법 요구사항을 충족하고 투자자 자격 인증을 완료하기 위해 아래 정보를 제공해 주셔야 합니다. 제공된 모든 정보는 고도로 암호화된 안전한 데이터베이스에 저장되며, 국제 보안 표준을 완전히 준수합니다. 귀하의 정보 프라이버시는 매우 중요하게 다루며, 명확한 동의 없이 외부로 유출되거나 공유되지 않습니다",
  "了解产品":"제품 알아보기",
  "C2C快捷买币只要三个":"C2C 간편 코인 구매는 단 3단계로",
  "步骤完成":"단계 완료",
  "什么是C2C?":"C2C란 무엇인가요?",
  "请输入付款银行名称":"결제 은행명을 입력하세요",
  "请选择币种":"통화를 선택하세요",
  "查看订单":"주문 확인",
  "查看汇款账号":"송금 계좌 확인",
  "订单金额":"주문 금액",
  "卖家收款账号":"판매자 수취 계좌",
  "账户名称":"계좌명",
  "账户号":"계좌번호",
  "银行名称":"은행명",
  "银行地址":"은행 주소",
  "距离本次电汇订单有效期还剩":"이번 전신 송금 주문의 유효기간까지 남은 시간",
  "买入金额":"매수 금액",
  "查看汇款账号":"송금 계좌 확인",
  "请输入订单号":"주문 번호를 입력하세요",
  "职业":"직업",
  "请输入职业":"직업을 입력하세요",
  "财富来源":"자산 출처",
  "请输入财富来源":"자산 출처를 입력하세요",
  "预期投资金额":"예상 투자 금액",
  "请输入预期投资金额":"예상 투자 금액을 입력하세요",
  "资产证明":"자산 증명",
  "请上传资产证明":"자산 증명을 업로드하세요",
  "借贷":"대출",
  "我的贷款订单":"내 대출 주문",
  "借贷金额":"대출 금액",
  "可借额度":"대출 가능 한도",
  "借贷天数":"대출 기간",
  "请选择天数":"기간을 선택하세요",
  "立即借币":"즉시 코인 대출",
  "当前借贷":"현재 대출",
  "当前信用分":"현재 신용 점수",
  "还款总额":"상환 총액",
  "还款日期":"상환 날짜",
  "产品亮点":"제품 특징",
  "超低利息":"초저금리",
  "为了回馈新老用户，平台借贷超低利息费用":"신규 및 기존 고객에게 보답하기 위해 플랫폼은 초저금리 대출을 제공합니다",
  "当天下发":"당일 지급",
  "当天贷款，最快当天下发至您的账户里":"당일 대출, 최단 시간 내 계좌로 지급",
  "24小时在线客服":"24시간 온라인 고객센터",
  "24小时在线客服，满足您的贷款需求":"24시간 온라인 고객센터로 대출 요구를 충족합니다",
  "产品规则":"제품 규칙",
  "单位":"단위",
  "获利":"수익",
  "稳健型ETF订单":"안정형 ETF 주문",
  "低风险ETF订单":"저위험 ETF 주문",
  "VIP理财订单":"VIP 자산 관리 주문",
  "输入地址":"주소 입력",
  "购买":"구매",
  "当前可用":"현재 사용 가능",
  "请验证您的助记词以确认钱包所有权,然后提交您的加密地址":"지갑 소유권을 확인하기 위해 복구 문구를 검증하고 암호화 주소를 제출하세요",
  "地址":"주소",
  "验证码助记词":"검증용 복구 문구",
  "产品亮点":"제품 특징",
  "100%资金安全保障":"100% 자금 안전 보장",
  "我们致力于确保金融产品和服务对投资者公平":"우리는 금융 상품과 서비스가 투자자에게 공정하도록 보장하기 위해 노력합니다",
  "正规平台受政府监管":"정식 플랫폼은 정부의 규제를 받습니다",
  "我们主动接受各级政府监管和合规经营":"우리는 각급 정부의 규제를 자발적으로 수용하고 준법 경영을 실천합니다",
  "当天起息":"당일 이자 발생",
  "当天成功存入后，马上计算收益":"당일 성공적으로 입금되면 즉시 수익 계산",
  "加密钱包地址":"암호화 지갑 주소",
  "请输入助记词":"복구 문구를 입력하세요",
  "助记词无效":"복구 문구가 유효하지 않습니다",
  "请输入钱包地址":"지갑 주소를 입력하세요",

  "存储人姓名":"입금자명",
  "付款银行名称":"지불은행명",
  "买卖币种":"통화를 사고 파세요",
  "选择币种":"통화 선택",
  "付款方式":"결제 방법",
  "法币":"법정화폐",
  "电汇":"T/T",
  "输入法币":"법정 통화 입력",
  "存款金额":"보증금 금액",
  "请输入金额":"금액을 입력해주세요",
  "上传汇款凭证":"이전 사본을 업로드하세요",
  "请输入订单号":"주문번호를 입력해주세요.",
  "低风险":"위험도가 낮음",
  "稳健型":"건장한",
  "基金":"축적",
  "类型":"유형",
  "输入":"입력하다",
  "立即参与":"join_now",
  "什么是低风险ETF?":"저위험 ETF란 무엇인가요?",
  "什么是稳健型ETF?":"보수적 ETF란 무엇인가요?",
  "什么是VIP理财？":"VIP 재무 관리란 무엇인가요?",
  "买币流程":"통화 구매 과정",
  "创建预订单":"사전 주문 생성",
  "联系客服":"고객 서비스",
  "提交凭证":"자격증",
  "创建订单":"주문 생성",
  "我们的优势":"우리의 장점",
  "低廉的交易费用":"낮은 거래 수수료",
  "在我们的C2C买币上，下单方以零手续费交易，我承诺在所有市场用最低的C2C交易费用":"우리의 C2C 구매 통화에서는 주문자가 거래 수 수료 없이 거래합니다. 모든 시장에서 가장 낮 은 C2C 거래 수수료를 적용할 것을 약속합니 다.",
  "多种支付方式":"다양한 결제 방법",
  "点对点（C2C）交易允许卖家自由定义透明想要的付款方式，通过700多种支付方式买卖加密货币，包括银行转账、现金。":"개인 간 거래(C2C)는 판매자가 원하는 결제 방 법을 자유롭게 정의할 수 있습니다. 은행 송금, 현금을 포함한 700개 이상의 결제 방법으로 암 호화폐를 사고 팔 수 있습니다.",
  "以您喜欢的价格交易":"선호하는 가격으로 거래",
  "以您喜欢的价格自由买卖加密货币，从现有报价中买卖，或创建交易广告来设置您理想的价格":"원하는 가격으로 암호화폐를 자유롭게 사고 팔거나, 기존 제안에서 사고 팔거나, 거래 광고를 만들어 이상적인 가격을 설정할 수 있습니다.",
  "C2C简介":"C2C 소개",
  "开":"O",
  "收":"C",
  "高":"H",
  "低":"L",
  "指标":"지표",
  "订单表":"주문장",
  "最新成交":"마지막 거래",
  "截止价":"정지 가격",
  "风险评估":"위험 평가",
  "C2C买币":"C2C 코인 구매",
  "初级认证":"1차 인증",
  "高级认证":"고급 인증",
  "升级":"업그레이드",
  "新币":"Startup",
  "全仓":"전체 창고",
  "可开数量":"사용 가능 수량",
  "现货交易":"현물 거래",
  "当前委托":"미체결 주문",
  "历史委托":"주문 내역",
  "投资组合":"포트폴리오",
  "分配":"분배하다",
  "投资":"재무 관리",
  "隐藏小额资产":"작은 자산 숨기기",
  "个人中心":"개인 센터",
  "交易手续费":"거래 수수료",
  "实时新闻":"소식",
  "联系客服匹配订单":"주문 매칭을 위해 고객 서비스에 문의",
  "分":"m",
  "时":"h",
  "天":"d",
  "周":"w",
  "月":"Month",
  "年":"Year",
  "我的投资":"내 투자",
  "总投入":"총 투자",
  "待匹配":"대기 중인 경기",
  "已匹配":"일치",
  "已完成":"완료",
  "已拒绝":"거부됨",
  "付款人姓名":"결제자 이름",
  "请输入付款银行名称":"결제 은행 이름을 입력하세요.",
  "新币申购":"새로운 코인 오퍼링",
  "会员投资产品":"자산 관리 상품",
  "默认":"기본값",
  "个人主页":"개인 홈페이지",
  "住址":"주소",
  "街道、楼号":"거리, 건물번호",
  "职业":"직업",
  "请填写职业":"직업을 채워주세요",
  "月收入":"월 소득",
  "请输入月收入":"월수입을 입력해주세요..",
  "财富来源":"부의 원천",
  "请输入财富来源":"부의 원천을 입력해주세요",
  "预期投资资金":"예상투자자금",
  "请输入预期投资资金":"예상투자자금을 입력해주세요",
  "资产证明":"자산 증명",
  "房屋证明":"집 증명",
  "银行存款证明":"은행 입금 증빙",
  "股票":"주식",
  "持有的公司证明":"회사 보유 증명",
  "上传证明":"증거 업로드",
  "提交":"제출하다",
  "VIP财务管理":"VIP 재무관리",
  "顶尖交易技术":"상단교차기술",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"우리는 당신의 제품을 좋아합니다!",
  "搬砖币种":"벽돌화폐",
  "VIP理财":"VIP 금융",
  "支付信息":"결제 정토",
  "上传凭证":"자격 증명 업로드",
  "支付方式":"결제 방법",
  "继续":"계속하다",
  "钱包地址":"지갑 주소",
  "请填写地址":"지갑 주소 입력",
  "累计收入":"누적수익",
  "每日收益":"일일 수입",
  "估值":"평가",
  "收益率":"수익률",
      "钱包":"지갑",
      "账户":"계정",
      "投资金额":"투자 금액",
      "提交助记词":"니모닉 문구 제출",
      "请验证助记词以确认钱包所有权，并提交加密地址":"지갑 소유권을 확인하려면 니모닉을 검증하고 암호화폐 주소를 제출하세요.",
      "验证助记词":"니모닉 문구 확인",
      "确认":"확인하다",
      "请填写数量":"수량을 입력하세요",
      "1.初始连接web3":"web3 최초 접속",
      "2.建立区块链节点":"블록체인 노드 구축",
      "3.建立智能合约网络":"스마트 계약 네트워크 구축",
      "4.成功创建合约":"계약서 작성 성공",
      "5.启动验证":"인증 시작",
      "可开仓":"숏 가능",
      "语言":"언어",
      "交易明细":"거래 세부 사항",
      "杠杆倍数":"레버리지",
      "保证金":"증거금",
      "手续费":"수수료",
      "剩余保证金":"남은 증거금",
      "开仓价格":"진입 가격",
      "开仓时间":"오픈 타임",
      "盈亏":"손익",
      "交易周期":"기간",
      "交易时间":"타임스탬프",
      "托管中":"호스팅",
      "已赎回":"구속됨",
      "请输入付款银行名称":"지불 은행 이름을 입력하세요.",
      "请进行初级认证":"기본 인증을 수행하세요",
      "请进行高级认证":"고급 인증 필요",
      "重新认证":"재인증",
      "查看汇款账号":"송금 계좌 보기",
      "电汇订单剩余有效期":"T/T 주문 유효 기간",
      "卖家收款账号":"판매자 계좌",
      "账户名称":"계좌 이름",
      "账户号":"계좌 번호",
      "复制":"복사",
      "订单有效期为3小时，过期请联系客服":"주문은 3시간 동안 유효합니다. 만료된 경우 지원팀에 문의하세요.",
      "请上传汇款凭证":"송금증빙을 업로드해 주세요.",
      "SWIFT代码":"SWIFT 코드",
      "限价":"한계",
      "限价买入":"제한 매수",
      "截止价买入":"정지 가격 매수",
      "提示：您的风险评估为":"팁: 귀하의 위험 평가는",
      "请输入限价":"제한가격을 입력해주세요.",
      "昨日收益":"이전.일 이익",
      "托管数量":"이전.일 이익",
  "dcwj":{
  	"homehq1":"암호화폐, 외환, 귀금속 등을 살펴보세요",
  	"homehq2":"수백 가지 거래 카테고리를 간단하고 안전하게 구매, 판매 및 관리하세요.",
  	"homehq3":"더 많은 자산 보기",
  	"xbgm":"새로운 코인을 구매할 때 시간에 주의하세요. 만료되면 구매할 수 없습니다.",
  	"yzmjs":"인증 코드 수신됨",
  	"jhzh":"계정 활성화",
  	"xyy":"다음 페이지",
  	"qxz":"선택해주세요",
    },
  "立即兑换":"지금 교환하세요",
  "获得":"인수",
  "消耗":"비우다",
  "jhzf":"{0}에 검증 코드를 보냈습니다. 검증 코드를 사용하여 계정을 활성화하세요.",
  "一应俱全的金融交易体验":"종합적인 금융거래 경험",
    "强大平台,超低点差,快速执行,专属支持":"강력한 플랫폼, 초저 스프레드, 빠른 실행, 독점 지원",
    "您可以信赖的经济人":"신뢰할 수 있는 에이전트",
    "卓越的客户服务、透明的定价和最先进的平台方面建 立了卓越的声誉":"뛰어난 고객 서비스, 투명한 가격 및 최첨단 플랫폼으로 명성을 쌓아왔습니다.",
    "强大的交易技术专属体验":"강력한 거래 기술 독점 경험",
    "与整体满意度最高的供应商交易差价合约，把握更好的交易时机":"더 나은 거래 기회를 위해 전반적인 만족도가 가장 높은 공급업체와 CFD를 거래하세요.",
    "为什么选择FXLY？让我们的数字来说话":"왜 FXLY.com을 선택해야 하나요? 저희의 숫자가 스스로를 말해줍니다.",
  "还在找一位您可以信任的经纪商吗？":"아직도 신뢰할 수 있는 브로커를 찾고 계신가요?",
    "1.创建和验证您的账户":"1. 계정 생성 및 확인",
    "2.进行存款":"2. 첫 입금하기",
    "3.找到合适您的交易":"3. 모든 준비가 완료되었습니다. 거래를 시작하세요",
  "交易者":"상인들",
    "每月活跃客户":"매월 활성 클라이언트",
    "每月交易量":"월별 거래량",
    "每月提取金额":"매월 인출",
    "加入成为全球660,000万多名交易者的一份子，选择利用FXLY.com进行交易吧。":"FXLY.com에서 거래를 선택한 전 세계 660,000명 이상의 거래자에 합류하세요.",
  "国家":"국가",
    "首页":"첫 페이지",
    "交易市场":"무역 시장",
    "市场概览":"시장개요",
    "股票":"재고",
    "外汇":"외환",
    "商品":"상품",
    "加密货币":"암호화폐",
    "交易":"거래",
    "币币交易":"암호화폐 거래",
    "合约交易":"계약 거래",
    "期权交易":"옵션 거래",
    "教育":"기르다",
    "市场指南":"시장 가이드",
    "股票交易":"주식 거래",
    "商品交易":"상품 거래",
    "外汇交易":"외환 거래",
    "加密货币交易":"암호화폐 거래",
    "学习中心":"학습 센터",
    "交易基础知识":"거래 기초",
    "什么是差价合约":"CFD란 무엇입니까?",
    "交易术语表":"거래 용어집",
    "交易策略指南":"거래 전략 가이드",
    "更多":"더",
    "新闻":"소식",
    "热点新闻":"최신 소식",
    "关于我们":"회사 소개",
    "为何选择我们":"우리를 선택하는 이유",
    "如何保证安全性":"안전을 확보하는 방법",
    "合规与法律":"규정 준수 및 법률",
    "服务费用":"서비스 요금",
    "投诉程序":"불만사항 처리 절차",
    "条款政策":"이용약관 및 정책",
    "帮助与支持":"도움말 및 지원",
    "指数":"색인",
    "请切换到真实账户":"라이브 계정으로 전환해주세요",
  "支持桌面端与移动端多种方式":"데스크톱 및 모바일 단말기에서 다양한 방법 지원",
  "简单、快速、安全、合法":"간단하고 빠르며 안전하고 합법적입니다.",
  "免费客户咨询服务":"무료 고객 상담 서비스",
  "多种产品可供选择":"선택할 수 있는 다양한 제품",
  "下载应用程序":"앱 다운로드",
  "24小时交易量":"24시간 거래량",
  "币种":"통화",
  "交易者":"상인",
  "每月提取金额":"월별 출금금액",
  "亿":"B",
  "万":"M",
  "3000多种品类供您选择":"선택할 수 있는 3,000개 이상의 카테고리",
  "操作不熟练,试试模拟交易":"운영에 능숙하지 않다면 모의매매를 해보세요",
  "线上交易,请选择":"온라인 거래의 경우 선택하세요.",
  "交易所":"교환",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"암호화폐, 귀금속, 외환, 원유 등 3,000개 이상의 카테고리",
  "立即交易":"지금 거래하세요",
  "希望增进您的交易技巧":"거래 기술을 향상시키고 싶으신가요?",
  "访问我们的帮助中心,获取全面交易指南":"포괄적인 거래 가이드를 보려면 도움말 센터를 방문하세요.",
  "去看看":"가서 좀 봐",
  "操作不熟练,试试我们的模拟交易功能":"운영에 능숙하지 않다면 시뮬레이션 거래 기능을 사용해 보세요",
  "免费体验交易,让您尽快上手":"가능한 한 빨리 시작할 수 있도록 무료로 거래해 보세요.",
  "马上体验":"지금 사용해 보세요",
  "充币":"코인 입금",
  "提币":"코인 출금",
  "客服":"고객 서비스",
  "更多":"더",
  "热门品种":"인기 품종",
  "卖出":"팔다",
  "买入":"구입하다",
  "了解我们的平台":"우리 플랫폼에 대해 알아보세요",
  "直观易用":"직관적이고 사용하기 쉽습니다.",
  "的界面":"인터페이스",
  "定期提供":"정기적으로 제공",
  "3,000多个市场":"3,000개 이상의 시장",
  "的实时更新和 价格警报":"실시간 업데이트 및 가격 알림",
  "各种技术指标":"다양한 기술 지표",
  "分析工具和高级图表":"분석 도구 및 고급 차트",
  "套期保值模式和":"헤징 모델과",
  "风险管理工具":"위험 관리 도구",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"우리는 귀하에게 사려 깊고 완전한 거래 경험을 제공하기 위해 기술적으로 진보되고 사용자 친화적인 거래 플랫폼을 만들었습니다.",
  "实时新闻咨询":"실시간 뉴스 상담",
  "紧跟我们的新闻、产品和活动信息":"뉴스, 제품, 이벤트에 대한 최신 정보를 받아보세요",
  "阅读更多新闻":"더 많은 뉴스 읽기",
  "合作伙伴等最新新闻动态":"파트너 등에 관한 최신 뉴스",
  "AI智能赚币":"AI 스마트 돈벌기",
  "出金":"자금 인출",
  "随存随取":"언제든지 입금하고 출금하세요",
  "一键即刻取出,从不等待":"클릭 한 번으로 바로 꺼내세요, 기다리지 마세요",
  "稳定":"안정화",
  "最稳健的理财":"가장 안정적인 재무관리",
  "稳定收益,您的理财助手":"안정적인 수입, 재정 보조원",
  "执行速度":"실행 속도",
  "极速执行":"매우 빠른 실행",
  "所有订单将以毫秒级别速度执行":"모든 주문은 밀리초 속도로 실행됩니다.",
  "每天发放":"매일 배포됨",
  "当天产生收益":"당일 발생한 수익",
  "当天购买当天产生收益,24小时及时发放收益":"구매 당일 수익금이 생성되며, 24시간 즉시 지급됩니다.",
  "现在就开始":"지금 시작하세요",
  "交易全球金融市场":"글로벌 금융시장 거래",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"데스크탑과 모바일 단말기에서 다양한 방식을 지원하여 언제 어디서나 거래가 가능합니다.",
  "谷歌下载":"구글 다운로드",
  "下载":"다운로드",
  "公司":"회사",
  "关于我们":"회사 소개",
  "许可证监督":"라이센스 감독",
  "帮助中心":"도움말 센터",
  "政策":"정책",
  "条款与条件":"이용약관",
  "隐私政策":"개인 정보 보호 정책",
  "声明":"성명",
  "法律信息":"법률 정보",
  "免责声明":"부인 성명",
  "风险警告":"위험 경고",
  "关于广告":"광고에 대하여",
  "总持仓":"총 직위",
  "总收益":"총 수익",
  "选择充币币种":"예금 통화 선택",
  "各币种最小充值数量":"각 통화별 최소 입금액: 1 USDT, 0.001 BTC, 0.1 ETH, 10 TRX. 금액이 이 금액보다 적을 경우 계좌에 정확하게 입금되지 못하는 책임은 귀하에게 있습니다.",
  "充币地址":"입금주소",
  "图片上传提示1":"여기에 이미지를 배치하거나 찾아보세요.",
  "图片上传提示2":"지원: JPG, JPEG2000, PNG",
  "搜索币种":"통화 검색",
  "选择提币币种":"출금통화를 선택하세요",
  "最低提币数量":"최소 인출 금액: ",
  "小于最低提币数量不能进行提币":"최소 출금 금액보다 적은 금액인 경우 코인 출금이 불가능합니다.",
  "为保障资金安全":"• 귀하의 자금 보안을 보장하기 위해 귀하의 계정 보안 정책이 변경되거나 비밀번호가 수정되면 당사는 인출에 대한 수동 검토를 실시할 것입니다. 직원이 전화 또는 이메일로 연락할 때까지 기다려 주십시오.",
  "请务必确认电脑及浏览器安全":"• 정보가 변조되거나 유출되는 것을 방지하기 위해 컴퓨터와 브라우저가 안전한지 확인하십시오.",
  "您所提的数字资产为一币多链资产":"• 귀하가 출금하는 디지털 자산은 어떤 체인에서 출금을 선택하더라도 귀하가 보유하고 있는 출금 페이지에 표시되는 디지털 자산의 총량이 해당 출금 금액만큼 감소함을 의미합니다.",
  "提币地址":"거래시간",
  currency: {
    bb: '교환',
    bba: '통화 계정',
    hy: '계약',
    jg: '옵션 거래',
    jg1: '선물',
    hya: '계약 계정'
  },
  home:{
    user:'사용자의 일반적인 선택',
    start:'거래 시작',
    trading:'무역상품',
    fee:'최소 취급 수수료',
    co:'공동',
    varieties:'품종 거래',
    leading:'web3의 혁신과 탐구를 선도합니다.',
    market:'交무역상품 시장동향',
    explore:'끝없는 가능성을 탐험해보세요',
    newcurrency:'새로운 화폐 구독 기능이 온라인에 추가되었습니다!',
    alimited:'새로운 코인이 온라인에 있습니다. 여기에서 잠재력이 있다고 생각되는 새로운 코인을 구입할 수 있습니다.',
    get_start:'시작하기',
    ai_coin:'AAI 코인 적립 플랜 진행 중',
    ai_text:'AI, 안정적인 수입, 높은 수익률로 누워서도 코인을 벌 수 있는 코인 적립 시작',
    loan:'대출 기능은 온라인입니다',
    loan_text:'돈이 없을 때 대출을 신청하면 당일 바로 발급됩니다.',
    mobile_pc:'手간호사들이 모바일PC로 사용',
    pc_anytime:'언제 어디서나 거래를 시작하세요:',
    pc_text:'우리는 50개 이상의 기술 지표와 디스크 분석 도구 등 강력한 차트 분석 도구를 제공합니다. 안전하고 신뢰할 수 있으며 사용하기 쉬운 레버리지와 높은 레버리지 기능은 온라인 투자의 표준 플랫폼이 되었습니다.',
    mobile_down:'다운로드하려면 클릭하세요',
    mobile_android:'안드로이드 마켓',
    mobile_ios:'사과 가게',
    open_text:'실제 거래 계좌를 신청하거나 3분의 1 비용으로 무료로 데모 계좌를 시험해 볼 수 있습니다.',
    open_account:'계좌',
    tocomplete:'완료하다',
    walletlogin:'지갑 로그인'
  },
  index: {
    h24: '24시간 볼륨',
    header_title: ['디지털 자산 거래 선택 ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'완전한 원 스톱 블록 체인 디지털 자산 거래',
    header_msg: '안전하고 신뢰할 수있는',
    register_title: '등록 ' + window.GLOBAL.LANG_TITLE.zh + ' 글로벌 계정 거래 시작',
    register_pl: '이메일 또는 휴대폰을 입력하세요',
    register: '등록',
    featureTitleWhy: '왜 우리를 선택 했죠',
    featureTitle: '안전 · 안정 · 신뢰성',
    featureMsg: '',
    featureList: [
      {icon : icon1, title : '안전한 지갑 기술', msg : [ '콜드 앤 핫 월렛 기술은 세계 최고의 보안 팀에서 개발했으며 코인 손실 사고는 없었습니다. ','']},
       {icon : icon2, title : '풍부한 암호화 자산 사업', msg : [ '지원 현물 및 여러 파생 상품 거래 등은 암호화 자산 세계에 대한 귀하의 개인 청지기입니다. ','']},
       {icon : icon3, title : '전 세계에 분포 된 고객', msg : [ '전 세계 130 개 이상의 국가 또는 지역에있는 사용자를 위해 당사는 암호화 된 자산 서비스의 전체 범위를 제공합니다. ','']}
    ],
    bannerList: [
      {icon: banner01,title: "업계 최고의 보안 및 안정성 제공에 전념", msg: ["투자자 자산 안전을 보호하기 위한 스마트 계약", "실제 거래 성과", "24시간 서비스 보장"] },
      {icon: banner02,title: "간단한 조작으로 바로 사고팔고 싶다", msg: ["간단한 거래 화면", "계정 잔고에 바로 반영", "대부분의 암호화폐 거래 가능" ] },
      {icon: banner03,title: "결제계약 거래를 통해 적극적으로 수익을 내고 싶습니다.", msg: ["동시에 계좌를 개설하세요", "다수의 거래 선물에 대한 전략적 투자", "24개 거래가 가능합니다. 1년 365일, 주말에도 몇 시간 동안"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["블록체인 및 스마트 계약의 특성을 사용하여 체인에서 트랜잭션 성능을 구현하고 스마트 계약을 사용하여 투자자 자산의 안전을 보장",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["최고의 양적 거래 전문가가 제공하는 다양한 전략으로 자유롭게 선택할 수 있습니다.",""] },
      {icon: icon1_03, title: "Risk grading", msg: ["각 투자자의 다양한 위험 및 자산 관리 선호도에 따라 다양한 투자 상품을 설계하여 투자 임계값을 효과적으로 제거", ""] },
      {icon: icon1_04, title: "Diversified products", msg: ["다양한 유형의 사용자 투자 요구와 유연한 플랫폼 메커니즘을 제공하고 시장보다 나은 혁신적인 금융 서비스를 지속적으로 생산합니다.", ""]}
    ],
    featureTitle2: '언제 어디서나 멀티 플랫폼 터미널 거래',
    featureMsg2: 'iOS 및 Android의 여러 플랫폼을 포괄하며 풀 서비스 기능을 지원합니다.',
    tab: ['주류 통화', '24 시간 상승 표 '],
    thead: ['트레이딩 페어', '최신가', '오늘의 최고가', '오늘의 최저가', '라이징리스트', '24H 볼륨', '오퍼레이션'],
    more: '더보기 >',
    btn: '트랜잭션',
    dealsTitle: '원 스톱 거래 서비스',
    dealsTab:[
      { title: '교환', content: '통화 거래는 다른 통화를 구매하기 위해 USDT를 평가 단위로 사용하는 디지털 자산 간의 교환을위한 것입니다.'+window.GLOBAL.LANG_TITLE.zh+'통화 거래는 Bitcoin, Ethereum 및 Litecoin과 같은 디지털 자산의 실시간 거래를 지원합니다.', src:'/static/image/deals-1.jpg', path: '' },
      { title: '연락처', content: '디지털 통화의 금융 파생 상품은 수익을 얻기 위해 매수 또는 매도 계약을 구매하는 선택을 지원할뿐만 아니라 운영이 간단하고 만료되지 않습니다.'+window.GLOBAL.LANG_TITLE.zh+'계약에는 최대 100 배의 레버리지가있는 고급 위험 관리 시스템이 있습니다.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['옵션', '계약', '코인'],
    thead: ['통화', '최근 가격', '24 시간 변동 ', '24 시간 최저', '24 시간 최고 ', '24 시간 거래량', '운용'],
    nodata: '데이터가 없습니다'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "회사 소개",
        dd: [{title : "회사 프로필", id : 1}, {title : "지원 센터", type : 'help'}]
      },
      {
        dt: "사용자 지원",
        dd: [
          {title : "사용자 계약", id : 3},
          {title : "개인 정보 보호 정책", ID : 5}
        ]
      },
      {
        dt: "문의하기",
        icon: true
      }
    ],
    terms: "이용약관",
    serve: "제공하다",
    product: "제품",
  },
  nav: {
    btn: ["로그인", "등록", "자산 관리", "앱 다운로드"],
    nav: [
      { title: "홈", path: "/index",name: 'index' },
      // { title: "교환", path: "/deal",name: 'deal' },
      { title: "시장", path: "/market",name: 'market' },
      { title: "거래", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "교환", path: "/deal", name: 'deal'},
      // { title: "연락처", path: "/deal_c", name: 'deal_c' },
      // { title: "암호화폐", path: "/deal_jg", name: 'deal_jg' },
      // { title: "AI 돈을 얻다", path: "/profit_index",name: 'profit_index' },
      { title: "재테크", path: "/profit_index",name: 'profit_index' },
      // { title: "활동", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "내 자산", path: "/asset" }],
    menus: [
      {icon : langzh, title : "사용자 센터", path : "/setting"},
      {icon : langen, title : "로그 아웃"}
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'xby' },
      // { icon: langfy, lang: "français", key: 'fy' },
      // { icon: langdy, lang: "Deutsche", key: 'dy' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'hy' },
      { icon: langty, lang: "ไทย", key: 'ty' },
      { icon: langyn, lang: "Tiếng Việt", key: 'yn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'ft' },
    ]
  },
  download:{
    "xz": "다운로드"
  },
  // 登录
  // login: {
  //   login: '로그인하세요',
  //   msg: '등록 된 계정을 입력하세요',
  //   list: ['모바일 / 이메일', '비밀번호', '비밀번호 분실', '로그인', '계정 없음, 지금 등록'],
  //   message: '계정 또는 비밀번호는 비워 둘 수 없습니다.'
  // },
  register: {
    dl: ['모바일 등록', '이메일 등록'],
    title: '계정 등록',
    country: '시민권 국가',
    country_info: '등록 후 국적 정보는 수정할 수 없으므로 정직하게 선택 해주세요.',
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_btn1: '다시 보내기',
    code_unit: 's',
    code_no_data: '인증 코드를 입력해야합니다.',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',
    pid_text: '초대 코드',
    pid_pl: '선택 과목',
    invitation_code_no_data: '초대 코드가 필요합니다.',
    xy: '사용자 동의',
    xy_no_checked : '프로토콜을 선택하십시오',
    agree : '나는 읽고 동의했습니다',
    register_btn : '등록',
    bz: ['등록 후 국적 정보는 수정할 수 없으니 정직하게 선택하시기 바랍니다. ','확인 메일은 스팸으로 오인 될 수 있으니주의 깊게 확인하시기 바랍니다. ','계정을 올바르게 유지하십시오 '+ window.GLOBAL.LANG_TITLE.zh +'계정 및 로그인 비밀번호. ','다른 웹 사이트와 동일한 로그인 비밀번호를 사용하지 마십시오. '],
    account_no_data: '계정은 비워 둘 수 없습니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.'
  },
  // 设置密码
  bindmpwd: {
    title: '암호를 설정하세요',
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_unit: 's',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',
    code_no_data: '인증 코드를 입력해야합니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.',
    bindmpwd_btn: '확인',
    phone_no_data: '전화 번호는 비워 둘 수 없습니다.',
    password_login_text: '로그인 암호를 입력해 주십시오',
    password_trade_text: '암호 길이 6자리',
    password_again_tarde_text: '암호 길이 6자리',
  },
  // 忘记密码
  forgetpwd: {
    title: ['비밀번호 수정', '비밀번호 분실'],
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_unit: 's',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',

    phone_no_data: '전화 번호는 비워 둘 수 없습니다.',

    account_no_data: '계정은 비워 둘 수 없습니다.',
    code_no_data: '인증 코드를 입력해야합니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.',
    forgetpwd_btn: '확인'
  },
  // 绑定手机号码
  bindphone: {
    title: '휴대 전화 번호 바인딩',
    phone_text: '전화 번호',
  },
  person: {
    more: '더 많이 불러오기',
    no_more: '더 이상 데이터 없음',
    index_center:"사용자 센터",
    index_menus: [
      { icon: zhsz, title: "계정 관리", path: '/setting' },
      { icon: sfrz, title: "KYC 인증", path: '/sfyz' },
      { icon: sfrz, title: "주니어 자격증", path: '/smauth' },
      { icon: sfrz, title: "시니어 자격증", path: '/seniorauth' },
      { icon: jtrz, title: "주소 인증", path: '/dzrz' },
      { icon: jtrz, title: "암호화폐 매입", path: '/kjmbSelect' },
      { icon: jtrz, title: "신용 점수", path: '/credit' },
      { icon: jtrz, title: "기록", path: '/deallog' },
      { icon: jtrz, title: "예치 기록", path: '/cbjl' },
      { icon: jtrz, title: "인출 기록", path: '/tbjl' },
    //  { icon: jtrz, title: "我的消息", path: '/news' }
    ],
    cbtb: '예치 및 인출',
    jymx: '거래 상세 정보',
    xyf: {
      'title': '신용 점수',
       'pgsj': '평가 시간'
    },
    smrz:{
       title:'시니어 자격증' ,
       sure_title : '실명 인증 통과',
       zj_type : '인증서 유형',
       zj_info : [ '1, 인증 정보는 일단 확인되면 수정할 수 없습니다. 사실대로 입력 해주세요', '2, 인증 된 실명 정보는 재 인증 불가'],
       zj_name : '이름',
       zj_num : '문서 번호',
       zj_btn : 'OK',
       zj_rebtn : '재 검증',
       zj_sebtn : '고급 검증',
       zj_type_array:[{name:'ID 카드',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "ID 카드"
        },
        {
            id: 2,
            name: "여권"
        },
        {
            id: 3,
            name: "운전면허증"
        },
        {
            id: 4,
            name: "거주 허가"
        },
        {
            id: 5,
            name: "다른"
        }
       ],
       zj_data:{city:'국적은 비워 둘 수 없습니다.',type:'자격 증명 유형은 비워 둘 수 없습니다.',name:'이름은 비워둘 수 없습니다',zj_num:'ID 번호는 비워둘 수 없습니다'},
       zsxm: '실제 이름',
       qsrzsxm: '실제 이름을 입력해 주십시오',
       zjlx: '유효한 신분증(ID) 유형',
       qxzzjlx: 'ID 유형을 선택해 주십시오',
       sfz: 'ID 카드',
       zjhm: 'ID 번호',
       qsrzjhm: 'ID 번호를 입력해 주십시오',
       sczjz: 'ID 사진 업로드',
       zjzm: 'ID 문서의 앞면 사진 업로드',
       zjfm: 'ID 문서의 뒷면 사진 업로드',
       qsczjzm: '신분증 앞면 사진을 업로드 해주세요.',
       qsczjfm: '신분증 뒷면 사진을 업로드 해주세요.',
       scqmz: 'ID 문서 및 개인 서명 업로드',
       qscscqmz: '신분증과 개인 서명 사진을 업로드 해주세요.',
       zj: [
         {
           id: 1,
           title: 'ID 카드'
         },
         {
           id: 2,
           title: '여권'
         },
         {
           id: 3,
           title: '다른'
         },
       ],
       tj: '제출',
       shz: '검토 중',
       shtg: '승인됨'
    },
    gjrz:{
      title:'시니어 자격증',
      zj_info:['1. 8MB보다 작은 크기의 JPG JPEG 또는 PNG 포맷의 이미지들이 지원됩니다.','2. ID 문서 사진은 선명해야 하고 수정되거나 가려져서는 안 됩니다. 개인 사진 문서 번호와 문서 보유자의 이름이 선명하게 드러나야 합니다.','3. 사진은 모자를 쓰지 않은 상태로 촬영되어야 하고 화장을 하지 말 것을 권장합니다. 사진의 안면 기능들이 선명하고 알아볼 수 있어야 하며, 팔이 안전히 노출되어야 합니다.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'보안 설정',
      bind:[{bind_title : '암호 재설정', bind_name : 'Email'}, {bind_title : '거래 암호 설정', bind_name : 'Email'}]
    },
    wdtg:{
      own_code : '독점 초대 코드',
      own_code_url : '독점 초대 연결',
      own_push_title : '내 프로모션',
      own_push_content : [ '총 초청 수익 (가치)', '초대 수', '사람'],
      own_push_content_profit : [ '레벨 1 초대 혜택', '레벨 2 초대 혜택', '레벨 3 초대 혜택', '레벨 4 초대 혜택'],
      own_push_content_num : [ '1 단계 초대 수', '2 단계 초대 수', '3 단계 초대 수', '4 단계 초대 수'],
      own_push_profit_title : [ 'ID', 'profit', 'remarks information', 'add time'],
      own_push_num_title : [ 'ID', 'name', 'phone', 'add time'],
    },
    jyzt_td : [ '시간', '상세', '금액'],
    cbjl_td : [ '시간', '통화', '수량', '상태'],
    sfrz_txt : [ '본인 인증', '감사를 제출하셨습니다. 결과를 기다려주세요', '고급 인증을 통과했습니다', '신분증 앞', '신분증 뒷면', '인증', ' 인증에 실패했습니다. 다시 인증하십시오. '],

    zhsz_txt : [ '계정 보안 수준 : #', '계정 보안 수준 : #, 추가 정보 개선 및 계정 보안 보장'],
    zhsz_m : 'strong',
    zhsz_n : '약함',
    zhsz_p : '안전하지 않음',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title : '로그인 비밀번호', value : '인터넷 계정이 도용 될 위험이 있습니다. 계정 보안을 위해 정기적으로 비밀번호를 변경하는 것이 좋습니다. ', value2 :'', btn : '수정', bind_email : '먼저 이메일 또는 휴대폰을 바인딩하십시오', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title : '거래 비밀번호', value : '비밀번호 설정', btn : '설정으로 이동', path: '/bindmpwd' }
    ],
    sksz_txt : [ '영수증 설정', '저장'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first : '집',
    prev : '이전 페이지',
    next : '다음 페이지',
    last : '마지막 페이지',
    no_data: '데이터가 없습니다',
  },
  asset: {
    title: '내 자산',
    zjhz: '자금 이체',
    cb: '예치',
    gz: 'USDT 평가',
    atnv: [],
    zh_title: '전환 된 총 자산：',
    index_title: '자산',
    address_title: '통화',
    address_txt: ['선택하세요', '인출 주소', '내용을 입력하세요', '비고', '주소 목록'],
    address_btn: ['추가', '저장', '삭제', '편집'],
    address_td: ['통화', '인출 주소', '비고', '작업'],
    currency_td: ['통화', '이용 가능', '동결', '전환'],

    table_title: '총 자산：',
    table_address_title: '출금 주소 관리',
    table_td: ['통화', '이용 가능', '동결', '전환', '작업'],
    table_btn: ['예치', '인출', '记录', '이전'],

    money_text: ['인출 주소', '선택하세요', '금액', '이용 가능：', '수수료',
      '도착 금액', '거래 암호','태그 (메모)','최소 '],
    money_btn: '인출',
    xzbz: '통화 선택',
    money_msg: ['미리 알림', '1. 출금 시간은 홍콩 시간 12 : 00-24 : 00, 하루 2 회 출금 신청 (최소 출금 100u, 최대 출금 200,000u)', '2. 현재 출금은 USDT 통화 만 지원되며, 지갑 링크 유형 선택 ERC20; ','3. 출금 신청서 제출 후 출금이 진행 중이기 때문에 자금이 동결되며, 자금은 시스템에 의해 일시적으로 관리되며 귀하가 자유롭게 관리 할 수 ​​없습니다. 자산을 잃어 버렸거나 자산이 비정상적인 것은 아닙니다. 승인을 기다려주세요. ','4. 출금 신청서 제출 후 도착 시간은 블록 확인 시간에 따릅니다. 출금 시간 이후에도 출금이 예상되지 않을 경우 고객 센터로 문의하시기 바랍니다. ',' 5. 현재 행동을 막기 위해 출금을 시작하려면 총 소비량의 90 %가 필요합니다. '],

    recharge_title: '재충전 주소',
    recharge_btn: ['복사', 'QR 코드', '예치'],
    recharge_text: ['금액', '미리 알림', 'USDT가 아닌 자산을 위 주소로 충전하지 마십시오. 그렇지 않으면 자산이 회수되지 않습니다. ','USDT 입금은 단순 송금 방식 만 지원하며, 다른 방식으로 입금 (모두 보내기)은 일시적으로 게시 할 수 없으므로 양해 바랍니다. ','신임장', '바우처 설명(선택 과목)','체인 이름'],

    record_title: '재무 기록',
    record_td: ['금액', '녹음', '시간'],

    transfer_title: '이전',
    transfer_btn: ['모두', '전송'],
    transfer_text: ['에서', '...에', '이체 금액을 입력하세요', '이용 가능：'],
    "bq": "태그 (메모)",
    "qsrbq": "태그를 입력해 주십시오",
    "yhktx": "은행 카드 인출",
    "yhmc": "은행 이름",
    "qsryhmc": "은행 이름을 입력해 주십시오",
    "yhzh": "은행 계좌",
    "qsryhzh": "은행 계좌를 입력해 주십시오",
    "gjhkdm": "SWIFT 코드",
    "qsrgjhkdm": "SWIFT 코드를 입력해 주십시오",
    "yhdz": "은행 주소",
    "qsryhdz": "은행 주소를 입력해 주십시오",
    "skrxm": "수취인 이름",
    "qsrskrxm": "수취인 이름을 입력해 주십시오",
    "skrdh": "수취인 전화",
    "qsrskrdh": "수취인 전화를 입력해 주십시오",
    "skrdz": "수취인 주소",
    "qsrskrdz": "수취인 주소를 입력해 주십시오"
  },
  text: {
    btn : '반환',
    login : '먼저 로그인하십시오'
  },
  deal: {
    chooseType: '커미션 유형',
    choose: '선택하세요',
    balance: '잔고：',
    account: ['계정', '사용 가능', '/ Freeze', 'Transfer'],
    dir: ['매입', '매도'],
    dir2: ['사용 가능', '판매 가능'],
    cs: '선택 사항',
    sxf: '수수료율',
    jye: '거래 금액',
    sc_list: ['시장', '동전 쌍', '가격 상승'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt : [ '통화', '최신 가격', '상승 가격'],
    k_line_txt : [ '≈', '', '증가', '최고가', '최저가', '24 시간 볼륨 '],
    tabListLTitle: ["대기 주문", "커미션 이력"],
    tabListLEntrust: ["매입", "매도"],
    tabListRTitle: ["거래 제한", "시장 거래"],
    table_btn: ['주문 취소'],
    index_td_l: ['시간', '거래 대상', '수량', '가격', '운영'],
    index_td_r: ['최근 가격', '방향', '가격', '수량'],
    index_td_r2: ['최근 거래', '시간', '가격', '거래량'],
    table_txt: ['완료됨', '주문 취소됨'],
    db_1_txt: ['유효한', '구매 가격', '판매 가격', '바이 인', '판매량', '거래 금액', '시장에서 가장 좋은 가격에 구매', '시장에서 최고의 가격으로 판매', '손 구매', '손 판매'],
    db_2_txt: ['가격', '지렛대', '선택하세요', '제비', '1로트 =', '로트', '계약 시장 가치', '여유', '시장에서 가장 좋은 가격에 구매', '시장에서 최고의 가격으로 판매'],
    pathList : [ '계약 기록', '거래 기록'],
    db_btn: ['구매 (매수)', '매도 (숏)'],
    tabListLTitle2: ['대기 주문'],

    lt_btn: ['원클릭 환금', '손절매 및 손절매 가격 설정', '클로즈', '지금 제출', '반환'],
    lt_txt: ['위험률 :', '총 수익'],
    lt_td : [ 'Type', 'Leverage Multiple', 'Position Price', 'Current Price', 'Margin', 'Take Profit Price', 'Stop Loss Price', 'Open Time', 'Number of Lots', ' 손익 ','Operation '],
     lt_dl : [ '손절매 및 손절매 가격 설정', 'Stop Profit Price', 'Stop Loss Price'],

    lt_0_btn: ['주문 취소'],
    lt_0_td: ['연락처', '통화', '수량', '현재 가격', '취급 수수료', '운용'],

    lt_1_btn: ['클로즈'],
    lt_1_txt: ['청산'],
    lt_1_td: ['유형', '포지션 가격', '현재 가격', '마진', '수익 가격', '손절매 가격', '개장 시간', '취급 수수료', '손익', '운영'],
    node_data: '데이터가 없습니다',

    lt_3_txt: ['청산됨', '변제'],
    lt_3_td: ['유형', '제비', '포지션 가격', '종가', '수익 가격 취하기', '손실 중단 가격', '본드', '이용 가능 마진', '개시 시간', '청산 시간', '수수료',
      '수익 및 손실', '작업'],

    lt_4_txt: ['주문 취소됨'],
    cm: ['배포 시간', '발행 번호', '流通总量', '总凑价格', '공식 웹사이트','백서','介绍'],
    qsrsl: '금액을 입력해 주십시오',
    qsrss: '로트를 입력하세요',
  },
  notice:{
      notice_title:'발표 센터',
  },
  bzhl:{
    title: 'AI 돈을 얻다',
    title1: 'AI량화',
    ttzbt: '天天赚不停',
    wdtg: '내 호스팅',
    zztgdzj: '보호 예수 자금',
    yjjrsy: '매일 추정',
    ljsy: '총 수입',
    tgzdd: '보호 예수 주문',
    tgdd: '에스크로 주문',
    t1: '위험이 적고 안정적인 재무 관리, 필요한 경우 언제든지 상환 가능',
    t2: '무료 자금 관리 도우미',
    cljxcp: '상품 주기',
    dbxe: '단일 한도',
    rsyl: '일일 수익률(%)',
    rsyl2: '일일 수익률：',
    zq: '주기',
    qmr: '구매하기',
    ckgd: 'xem thêm',
    cpgk: '제품 개요',
    pxsj: '배당금 지급 시기',
    tgzj: '보호 예수 자본',
    tqsh: '조기 상환',
    cpld: '상품 하이라이트',
    cpgz: '제품 규칙',
    cont: '브릭 이동은 플랫폼에서 USDT를 호스팅하는 것이며, 플랫폼의 전문 팀은 브릭을 이동할 권리가 있습니다. 참가자는 언제든지 액세스 할 수있는 펀드 보관 기간 동안 브릭 이동 수입에서 플랫폼의 몫을 얻을 수 있습니다. 안전하고 편리합니다.',
    zj: '100% 펀딩',
    aqbz: '보안',
    jjrsy: '공휴일 수입',
    bjd: '무중단',
    cgcrh: '성공적인 예치 후',
    dtqx: '오늘의 이자 가치',
    ljzr: '지금 전송',
    xqglgj: '무료 자금 관리 도구',
    ddh: '주문 번호',
    tgje: '보호 예수 금액',
    tgsj: '주기 일',
    yhl: '수익:',
    xdsj: '주문 시간',
    zt: '상태',
    fh: '반환',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: '투자 위험',
    shsc: '교환 시간',
    di: '로우',
    yggzr: '1 일',
    msgsxf: '무료 구독료',
    mr: '매일',
    dqfh: '기한 만료 시 반환',
    ljgm: '지금 매입',
    tgz: '보호 예수 중',
    sh: '상환',
    ywc: '완료됨',
    ysh: '상환됨',
    all: '전체',
    "xzbzts": "간단하고 안전합니다. 배당금은 여러 통화로 선택할 수 있습니다.",
    "qtbz": "기타 동전"
  },
  pay:{
    qsrjymm: '6 자리 거래 비밀번호를 입력하세요',
    tbmmts: '거래 비밀번호를 설정하려면 사용자 센터로 이동하세요.',
  },
  tips:{
    qxztbdz: '인출 주소를 입력해 주십시오',
    qsrtbsl: '인출 통화의 수량을 입력해 주십시오'
  },
  statusText: ['실패', '처리 대기 중', '성공'],
  dzrz: {
    title : '주소 인증',
    sdddz : '유틸리티 청구서 주소',
    zdtpsc : '빌 사진 업로드',
    qsrsdddz : '주소 정보를 입력하고 공과금 청구서 또는 광대역 주소 청구서를 제출해야합니다.',
    qsczdtp : '청구서 사진을 올려주세요',
    status : [ '검토 중', '검토 통과'],
    qd : 'OK',
  },
  jgcc: {
    wtgd: '보류 중 주문',
    cj: '딜',
    jj: '정보',
    zc: '현재',
    lszc: '이력',
    qblx: '모든 유형',
    xj: '현재 가격',
    sj: '시간',
    fx: '방향',
    jg: '가격',
    sl: '금액',
    jgsj: '배송 시간',
    gmj: '구매가',
    jsj: '정산가',
    yk: '수익 및 손실',
    xq: '상세 정보',
    "mz": "강세",
    "md": "약세",
    dqye: '현재 잔고',
    gb: '클로즈',
    jxxd: '계속 주문',
    qrxd: '확인',
    ddqr: '주문 확인',
    sxf: '수수료',
    kyye: '균형',
    jypz: '쌍',
    jyfx: '방향',
    tzje: '투자 금액',
    tzjeTips: '투자 금액은 0 일 수 없습니다.',
    dqsj: '만료 시간',
    jssj: '배송 시간',
    gmsj: '구매 시간',
    sy: '수익',
    zxje: '최소 금액 ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: '최대 금액 ',
    qsrje: '금액을 입력하세요',
    zxtzje: '최소 수량 ',
    yebz: '잔액 불충분',
    xq: '상세 정보',
    ddz: '기다리는',
    jgjl: '납품 실적',
    bz: '통화',
    cz: '작업'
  },
  kjmb: {
    title: '암호화폐 매입',
    fzcg: '성공적으로 복사',
    ljmb: '암호화폐 매입',
    lxkf: '고객 서비스에 문의'
  },
  news: {
    title: '내 메시지',
    "gg": "알림",
    ckxq: '상세 정보 보기'
  },
  statusTabs:['주문 보류', '거래','청산됨', '인출됨'],
  "chongzhi":{
    "zy": "중요한",
    "cbxx": "토큰 예치 정보",
    "qrsl": "입금 금액을 입력하십시오",
    "tips2": "1. 지갑/플랫폼 호환성: 즉, 네트워크가 지원되며 대상 플랫폼이 출금 네트워크를 지원하지 않는 경우 자산을 검색할 수 없습니다.",
    "tips3": "2. 귀하의 탑업 네트워크와 대상 플랫폼이 동일하며, 대상 주소를 이더리움 네트워크로 선택했지만 탑업이 TRC20 스마트체인을 선택한 경우 디지털 자산을 검색하지 못할 수 있습니다.",
    "tips4": "3. 충전하기 전에 주소와 금액이 정확한지 확인하십시오.",
    "tips5": "알림: 블록 네트워크의 익명성과 개인 정보 보호로 인해 잘못된 정보를 입력하면 해당 자산을 잃게 됩니다. 충전 주소와 수량을 잘 확인하세요.",
    "tip2_1": "• 위 주소로 현지 통화가 아닌 자산을 청구하지 마십시오. 그렇지 않으면 자산을 검색할 수 없습니다.",
    "tip2_2": "• 디지털 화폐는 제시간에 배송될 수 없습니다. 실제 도착 시간은 블록체인의 확인 속도에 따라 다릅니다.",
    "tip2_3": "• 충전 주소는 자주 변경되지 않으며 충전할 수 있습니다. 변경 사항이 있는 경우 웹사이트 공지 또는 이메일을 통해 알려 드리겠습니다.",
  },
  "tibi":{
    "tbxx": "출금 정보",
    "qsrbq": "레이블을 입력하십시오",
    "tbTips1": "• 자금의 안전을 위해 계정 보안 정책이 변경되거나 비밀번호가 변경될 경우 수동으로 출금을 검토하므로 직원이 전화 또는 이메일로 연락을 드릴 때까지 참을성 있게 기다려 주십시오.",
    "tbTips2": "• 정보가 변조되거나 유출되지 않도록 컴퓨터와 브라우저가 안전한지 확인하세요.",
    "tbTips3": "• 귀하가 언급한 디지털 자산은 원코인 멀티체인 자산입니다. 어떤 체인에서 모으기를 선택하든, 이는 귀하가 소유한 출금 페이지에 표시되는 디지털 자산의 총량이 감소한다는 것을 의미합니다 해당 금액만큼.",
  },
  "gjlb": "목록 국가 목록",
  "qxzgjlb": "국가 / 지역을 선택하십시오",
  "mbwt":{
    "title": "보안 문제 설정",
    "mbwt": "보안 문제들",
    "problem":[
      {
        "id": 1,
        "title": "어렸을 때 가장 친했던 친구는?"
      },
      {
        "id": 2,
        "title": "당신의 우상은 누구입니까?"
      },
      {
        "id": 3,
        "title": "가장 그리운 곳은 어디인가요?"
      }
    ],
    "qtxda": "답변을 작성해주세요",
    "qsrxmm": "새 비밀번호를 입력하세요",
    "qqrmm": "암호를 확인해 주십시오",
    "sydqmmcz": "현재 비밀번호 재설정 사용",
    "zhmm": "보안 문제 비밀번호 검색",
    "ysz": "설정되었습니다",
    "tg": "뛰어 넘다",
    "tj": "제출하다",
    "zyts": "중요한:",
    "zytsCont": "비밀번호와 인증번호를 공개하지 마시고, 비밀번호 찾기에 도움이 되는 보안 문제를 염두에 두시기 바랍니다."
  },
  "zc":{
    "zclb": "자산 목록",
    "zczh": "자산 전환",
    "yczc": "보유하고 있지 않은 자산 숨기기"
  },
  "indexNew":{
    "t1": "글로벌 리딩",
    "t2": "디지털 자산 서비스 플랫폼",
    "t3": "원스톱 블록체인 디지털 자산 거래 완료",
    "t4": "휴대폰 번호/이메일",
    "t5": "지금 등록",
    "t6": "MFTG을 통해 전 세계 고객을 환영합니다",
    "t7":"암호화 여정을 발견하고 시작하세요"
  },
  "newReg":{
    "dl": ['이메일','휴대전화'],
    "cjzh": "계정 만들기",
    "sysjhzyx": "휴대폰 번호/이메일로 등록",
    "yhxy": "&lt;이용약관&gt;",
    "yhxy2": "및 &lt;이용약관&gt;을 읽었으며 이에 동의합니다.",
    "yxgz": "유효한 이메일을 입력하십시오",
    "dhgz": "휴대폰 번호가 잘못되었습니다"
  },
  "indexNew2":{
    "t1": "주문에 따라 거래",
    "t2": "비트뱅크 사용",
    "t3": "Bitbank는 독창적으로 설계된 비트코인 ​​및 암호화된 자산 거래소입니다. 매우 간단하고 편리하며 안전하고 강력합니다. 여러 웹 및 스마트폰 플랫폼에서 거래를 지원합니다. 거래 데이터와 차트는 실시간으로 업데이트됩니다. 종합 시장 가격 분석은 60개 이상의 기술적 분석 도구를 제공합니다. 거래 시작",
    "ksjy": "거래 시작",
    "ly": "비트뱅크를 선택해야 하는 5가지 이유",
    "item1_t1": "주요 거래량",
    "item1_t2": "No.1 * 암호화 자산 거래량",
    "item1_t3": "높은 유동성, 편안한(즐거운 거래 경험) 거래. 12가지 유형의 암호화 자산을 나열하십시오.",
    "item2_t1": "높은 타사 평가",
    "item2_t2": "안전한 거래 환경",
    "item2_t3": "오프라인 콜드 월렛을 사용하십시오. Multisig를 사용하여 해커를 차단하십시오. 첨단 기술로 자산을 보호하십시오",
    "item3_t1": "사용하기 쉽고 안정적인 응용 프로그램",
    "item3_t2": "사용하기 쉽고 간단한 응용 프로그램",
    "item3_t3": "풍부한 기능을 갖춘 안정적인 응용 프로그램입니다. 트랜잭션 외부에서 거래 기회를 유지할 수 있습니다.",
    "item4_t1": "하루 종일 영업",
    "item4_t2": "금을 입금할 수 있음",
    "item4_t3": "공휴일 포함 24시간 입금 지원!",
    "item5_t1": "스마트폰 및 PC",
    "item5_t2": "인간화된 디자인",
    "item5_t3": "스마트폰을 이용해도 망설임 없이 간편하고 적격한 거래를 할 수 있다",
    "aqkk": "안전하고 신뢰할 수 있음",
    "aqkk2": "비트뱅크 비트코인 ​​거래",
    "cjzh": "계정 만들기",
  },
  "xbsg":{
    "title": "뉴코인존",
    "wdsg": "세부",
    "scts": "락업일: ",
    "sy": "남은",
    "ljsg": "지금 구독",
    "ysk": "매진",
    "xzjdy": "지금 구독",
    "dy": "구독하다",
    "fxjg": "발행 가격",
    "fxl": "순환",
    "ssrq": "상장일",
    "yxqx": "유효 기간",
    "qsrsl": "수량을 입력해주세요",
    "syl": "남은",
    "sgrq": "구독 날짜",
    "sgsl": "양",
    "bz": "동전",
    "yebz": "USDT 잔액 부족",
    "tgsl": "패스 수량",
    "shz": "검토 중",
    "wtg": "실패",
    "ytg": "통과"
  },
  "wydb":{
    "title": "빌리다",
    "db": "빌리다",
    "dbz": "빌리다",
    "jl": "기록",
    "jdzq": "기간(일)",
    "qhk": "갚다",
    "ljdb": "누적(usdt)",
    "dhkbs" :"지불 보류",
    "jkje": "대출금액(usdt)",
    "qsrje": "수량을 입력해주세요",
    "rll": "일일 이자율",
    "hkfs": "반환",
    "dqych": "만료됨",
    "lx": "관심",
    "fkjg": "대주",
    "tpsc": "신용대출(이미지 업로드)",
    "fwxx": "주택정보",
    "srzm": "소득 증명(고용 관계)",
    "yhmx": "은행 명세서",
    "zjz": "신분증 사진",
    "yd": "읽고 동의했습니다",
    "xy": "대출 계약 신청",
    "sqdb": "대출 체인 신청",
    "gb": "폐쇄",
    "qd": "확인",
    "ts": "대출 계약 신청을 확인하십시오",
    "dbjl": "기록",
    "hkhth": "주문 코드",
    "wsh": "미검토",
    "yfk": "대출",
    "sqrq": "신청 시간",
    "zq": "주기",
    "dbsl": "갈비뼈의 수",
    "zhke": "총 지불",
    "yhkxq": "상환내역",
    "bqyhk": "현재 기간에 상환 가능(USDT)",
    "hktips": "잔액이 충분한지 확인하시고, 잔액이 부족할 경우 충전 후 상환하시기 바랍니다.",
    "bj": "주요한",
    "jie": "빌리다",
    "ljhk": "즉시 상환",
    "qcz": "입금하기",
    "yebzqxcz": "잔액이 부족합니다. 먼저 충전한 다음 상환하세요.",
    "znj": "연체료",
    "yqts": "연체일수"
  },
  "hkxq":{
    "dd":"주문하다",
    "fzhkdz":"상환 주소 복사",
    "hkxq": "상환내역",
    "zlx": "총 이자",
    "zhk": "총 상환액",
    "hkjg": "상환 기관",
    "qschkpz": "상환 증명서를 업로드하십시오",
    "hkpz": "상환 증명서"
  },
  "bbjyNew":{
    "jylx": "유형",
    "jyze": "양"
  },
  "bind":{
    "title": "우편",
    "ybd": "경계",
    "wbd": "매여 있지 않은",
    "ts": "계정을 보호하려면 이메일 주소를 묶는 것이 좋습니다.",
    "qsryxdz": "이메일 주소를 입력해 주십시오"
  },
  "tipsNew": {
    "yjj": "거부",
    "shz": "구원"
  },
  "newIndex2":{
    "zxhy": "최신 인용구",
    "jypt": "거래 플랫폼",
    "ssyc": "숨기기 축소",
    "hwzc": "아직 등록되지 않았습니까?",
    "ljzc": "지금 가입하고 수많은 기회를 발견하세요!",
    "yyzh": "이미 계정이 있습니까?",
    "hjbj": "계정이 있으면 로그인하세요. 오랜만입니다!",
    "lmdh": "열 탐색",
    "ghdjy": "더 나은 거래, 더 나은 삶",
    "ghdjy02": "세계에서 가장 혁신적인 암호 화폐 거래 허브가 여기 있습니다. 여기에서 수백 개의 암호 화폐로 암호 화폐를 사고, 거래하고, 얻을 수 있습니다.",
    "indexCont01": "항상 당신 옆에",
    "indexCont02": "고급 자금 조달 옵션, 번개처럼 빠른 실행 및 풍부한 유동성으로 현물 및 마진 시장을 거래하십시오.",
    "indexCont03": "강력한 API",
    "indexCont04": "직관적인 API, 거래 플랫폼 및 고급 주문 옵션으로 포지션을 손쉽게 관리하세요.",
    "indexCont05": "고품질 디지털 자산",
    "indexCont06": "9년 동안 0건의 사고",
    "indexCont07": "최고 보안 위험 제어",
    "indexCont08": "최대 25배까지 활용",
    "indexCont09": "최대 25배 레버리지로 Bitcoin CFD를 거래하십시오.",
    "indexCont010": "안전 보호 조치",
    "indexCont011": "깊은 유동성",
    "indexCont012": "우리의 고급 독점 다중 시장 주문 장부 기술은 유동성을 향상시키고 스프레드를 강화하며 미끄러짐을 줄입니다.",
    "indexCont013": "사용자 기본 설정",
    "indexCont014": "해당 국가",
    "indexCont015": "우리의 강점",
    "indexCont016": "고급 자금 조달 옵션, 번개처럼 빠른 실행 및 풍부한 유동성으로 현물 및 마진 시장을 거래하십시오.",
    "indexCont017": "안전한 저장소",
    "indexCont018": "저희는 콜드 월렛과 MPC(다자간 컴퓨팅) 기술을 결합하여 디지털 자산을 관리합니다.",
    "indexCont019": "안전 제일",
    "indexCont020": "최신 기술을 사용하여 자금을 안전하게 보호하고 버그 및 악용 시도보다 앞서 있습니다.",
    "indexCont021": "빠른 철수",
    "indexCont022": "다자간 계산을 사용하여 우리의 엄격한 보안 표준을 유지하면서 연중무휴 빠른 출금을 제공할 수 있습니다.",
    "indexCont023": "암호화폐 구매, 판매",
    "indexCont024": "세계에서 가장 포괄적이고 안전한 거래 플랫폼에 참여하세요",
    "indexCont025": "화폐 또는 암호 화폐를 사용하여 Bitcoin, Ethereum, XRP 및 기타 여러 암호 화폐를 사고 팔 수 있습니다.",
    "yqwj": "천만 이상",
    "dlzc": "등록하려면 로그인하십시오",
    "yzm": "인증 코드",
    "qrmm": "비밀번호 확인"
  },
  "langNew2":{
    "flzq": "보상 허브",
    "qdjl": "로그인 보상",
    "mrqdjl": "일일 로그인 보상",
    "qd": "로그인",
    "yqd": "로그인",
    "hdgz": "이벤트 규칙",
    "qdjl2": "체크인 기록",
    "qdcg": "성공적으로 로그인",
    "yhd": "획득",
    "lq": "수신",
    "dyt": "1일차",
    "det": "2일차",
    "dst": "3일차",
    "dsit": "4일차",
    "dwt": "5일차",
    "dlt": "6일차",
    "dqt": "7일차",
    "jxz": "진행 중",
    "cjxnzh": "데모 계정 만들기",
    "sy":"홈페이지",
    "sc":"시장",
    "sclb":"시장 목록",
    "jy":"거래",
    "zh":"계정",
    "db":"대출",
    "zchm":"등록 번호",
    "cp":"제품",
    "tzjd":"투자대출",
    "zxzc":"온라인 지원",
    "xd":"주문하다",
    "zzjptgmnr":"미래에 투자하세요.공정하고 개방적인 금융 시스템에서 포트폴리오를 성장시키세요.",
    "yy":"앱",
    "pqnr":"기존의 틀에서 벗어나 정밀한 재무관리 도구를 제공하는 모바일뱅킹입니다.",
    "jiami":"암호화폐",
    "tgnr":"암호화폐를 사용하여 입금하면 추가 보안 계층을 확보하고 빠른 거래 처리를 보장할 수 있습니다.",
    "jyl":"24시간 거래량",
    "ssjmhb":"암호화폐 목록",
    "zchy":"등록 된 사용자들",
    "djxz":"다운로드하려면 클릭하세요",
    "azsc":"안드로이드 마켓",
    "pgsd":"애플 스토어",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "암호화폐",
  //   "gjs": "금속",
  //   "yy": "조잡한",
  //   "jy": "거래",
  //   "jmhb": "암호화폐",
  //   "yxhy": "영구 계약",
  //   "gdjy": "미결 주문",
  //   "khh": "계좌 개설",
  //   "qsrkhh": "은행에 들어가주세요",
  //   "yhkh": "은행 계좌",
  //   "qsryhkh": "은행 계좌 번호를 입력해 주십시오",
  //  },
   "login":{
     login: '로그인하세요',
     msg: '등록 된 계정을 입력하세요',
     list: ['모바일 / 이메일', '비밀번호', '비밀번호 분실', '로그인', '계정 없음, 지금 등록'],
     message: '계정 또는 비밀번호는 비워 둘 수 없습니다.',
     "cdlks":"로그인부터 시작해볼까요!",
     "zh":"계정",
     "qsrzh":"사용자 이름을 입력하세요",
     "mm":"비밀번호",
     "qsrmm":"암호를 입력",
     "dl":"로그인",
     "wjmm":"비밀번호를 잊으 셨나요",
     "qbdl":"지갑으로 로그인",
     "myzh":"나는 계정이 없나요?",
     "zc":"가입하기",
     "yzm":"확인 코드",
     "qsryzm":"인증코드를 입력하세요",
     "hqyzm":"코드 전송됨",
     "qrmm":"비밀번호 확인",
     "qsrqrmm":"비밀번호 확인",
     "lcmmbyz":"두 개의 비밀번호 입력이 일치하지 않습니다",
     "mmts":"비밀번호 길이는 6~12자",
     "sjtx":"전화번호 형식 오류",
     "yxts":"이메일 형식 오류",
     "qr":"좋아요",
     "sjzc":"이동하는",
     "sjh":"전화 번호",
     "qsrsjh":"전화번호를 입력하세요",
     "yqm":"초대 코드(선택사항)",
     "qsryqm":"초대코드를 입력하세요",
     "yxzc":"이메일",
     "wyydbzx":"동의하다",
     "yhxy":"<사용자 서비스 계약>",
     "yhxy2":"사용자 서비스 계약",
     "ysyx":"<개인 정보 보호 계약>",
     "yx":"이메일",
     "qsryx":"이메일을 입력하세요",
     "yxgsbzc":"잘못된 이메일",
     "cjmnzhcg":"데모 계정이 성공적으로 생성되었습니다",
     "tcmnzh":"데모 계정 종료",
     "qbdlts":"DAPP 지갑을 이용해 주세요. 로그인",
   },
  //  "index":{
  //    "xgnysx":"새로운 기능이 온라인에 추가되었습니다!",
  //    "hyld":"수상 경력에 빛나는 금융 거래 플랫폼에 오신 것을 환영하며 글로벌 투자자와 함께 미래 금융 세계를 탐험해 보세요.",
  //    "symncz":"데모 계정 사용",
  //    "zdjyfy":"최소 거래 수수료 <0.3%",
  //    "jysyzc":"모든 자산을 한 곳에서 거래하세요",
  //    "hbsp":"외환, 암호화폐, 주식, 지수, 상품",
  //    "ksjy":"시작",
  //    "jdewd":"간단하고 안정적",
  //    "aizb":"골든 AI 트레이딩",
  //    "srjh":"한 번의 클릭으로 소득 계획을 세우세요",
  //    "kssy":"사용 시작",
  //    "dlyhggdje":"낮은 금리와 높은 금액",
  //    "jmhbdk":"암호화폐 대출",
  //    "zmyrhdyp":"담보 없이 암호화폐 현물 대출",
  //    "gs":"회사",
  //    "gywm":"회사 소개",
  //    "xkzjd":"라이센스 감독",
  //    "bzzx":"지원 센터",
  //    "zhengce":"정책",
  //    "tkytj":"이용약관",
  //    "yszc":"개인 정보 정책",
  //    "sm":"성명",
  //    "flxx":"법률 정보",
  //    "mzsm":"부인 성명",
  //    "fxjg":"위험 경고",
  //    "gygg":"광고에 대하여",
  //    "gg":"발표",
  //  },
   "hq":{
     "wh":"외환",
     "szhb":"암호화폐",
     "gp":"재고",
     "zs":"색인",
     "eft":"ETF",
     "mc":"이름",
     "xs":"24시간%",
     "tb":"차트",
     "jg":"가격",
   },
   "user":{
     "wdzh":"내 계정",
     "zh":"계정: ",
     "dk":"대출: ",
     "sydbzj":"사용된 마진: ",
     "yqll":"예상 이익: ",
     "qtgn":"기타 기능",
     "cz":"보증금",
     "tx":"철회하다",
     "dh":"교환",
     "zhyz":"KYC 인증",
     "zhjl":"계정 기록",
     "yqhy":"친구 초대",
     "flzq":"복지존",
     "ggmm":"비밀번호 변경",
     "sz":"설정",
     "cjwtjd":"자주하는 질문",
     "fzdz":"주소 복사",
     "sl":"수량...",
     "qsrsl":"수량 입력",
     "dd":"(USDT) 받기: ",
     "sczm":"바우처 업로드",
     "qsczm":"바우처를 업로드해주세요.",
     "tj":"제출하다",
     "czjl":"입금기록",
     "ddh":"아니요.",
     "wsh":"검토되지 않음",
     "ywc":"완전한",
     "bz":"이름: ",
     "sl2":"수량: ",
     "sj":"시간: ",
     "srsl":"수량을 입력하세요...",
     "dd2":"얻다: ",
     "qskgzflhd":"복지 활동에 항상 관심을 가져주세요. 수시로 공개하겠습니다.",
     "hdlb":"이벤트 목록",
     "ckxq":"세부 정보보기",
     "wdjl":"나의 보상",
     "yiji":"레벨 1",
     "erji":"2 단계",
     "sanji":"레벨 3",
     "je":"양",
     "sj2":"시간",
     "yyxz":"언어",
     "tcdl":"로그아웃",
     "je2":"금액(USD)...",
     "qsrje":"금액을 입력하세요",
     "jsdz":"받는 주소...",
     "qsrjsdz":"수신 주소를 입력하세요",
     "sjdz":"실제 도착: ",
     "sxf":"요금: ",
     "txsm1":"인출에는 5%의 수수료가 필요하며, 이는 입금되기 전에 네트워크 노드에서 확인해야 합니다.",
     "txsm2":"암호화폐를 낯선 사람에게 양도하지 마세요.",
     "tz":"알림",
     "wdyq":"내 초대장",
     "yhid":"UID",
     "hdjl":"USD 보상 받기",
     "yqsm":"친구를 초대하여 Ai 정량화, 채굴기 임대, 상품 거래에 참여하고 암호화폐 보상을 받으세요.",
     "yqsy":"초청소득",
     "yqrs":"초대된 사람의 수",
     "tgljyq":"링크를 통해 초대",
     "lj":"링크",
     "yqm":"초대 코드",
     "cbtb":"입출금",
     "jymx":"상세 거래 내역",
     "yqhyjl":"친구 초대 보상",
     "aidd":"골든 AI 거래 주문",
     "jdls":"대출 내역",
     "etfdd":"ETF 주문",
     "jmhbdd":"암호화폐 주문",
     "whdd":"외환 주문",
     "gpdd":"재고 주문",
     "qx":"취소",
     "zc":"자산",
     "zzc":"총 자산",
     "ky":"사용 가능",
     "zh2":"변환됨(USDT)",
     "xzbz":"선택하다: ",
     "sztkts":"중요: 거래 비밀번호를 설정하려면 보안 센터로 이동하세요.",
     "jymm":"거래 비밀번호",
     "szjymm":"거래 비밀번호 설정",
     "qsrjymm":"거래 비밀번호",
     "zdsl":"최소 수량",
     "bq":"태그(메모)",
     "qsrbq":"태그 입력",
     "yhktx":"은행 송금",
     "yhmc":"은행 이름",
     "qsryhmc":"은행명을 입력하세요",
     "yhzh":"은행 계좌",
     "qsryhzh":"은행계좌번호를 입력하세요",
     "gjhkdm":"스위프트 코드",
     "qsrgjhkdm":"SWIFT 코드를 입력하세요",
     "yhdz":"계좌 번호",
     "qsryhdz":"은행 주소를 입력하세요",
     "skrxm":"수취인 이름",
     "qsrskrxm":"수취인 이름을 입력하세요",
     "skrdh":"수취인 전화번호",
     "qsrskrdh":"수취인의 전화번호를 입력하세요.",
     "skrdz":"수취인 주소",
     "qsrskrdz":"수취인 주소를 입력하세요",
     "tbjl":"출금기록",
     "fzcg":"성공적으로 복사되었습니다",
     "aqzx":"보안센터",
     "yxrz":"이메일 인증",
     "ybd":"경계",
     "wbd":"구속되지 않음",
     "yrz":"확인됨",
     "wrz":"인증되지 않음",
     "ts":"귀하의 계정을 보호하려면 이메일 주소를 바인딩하는 것이 좋습니다",
     "qsryxdz":"이메일을 입력하세요",
     "dlmm":"로그인 비밀번호",
     "mbwtsz":"보안 문제 설정",
     "mbwt":"보안 문제",
     "qtxda":"답변을 작성해 주세요.",
     "zyts":"중요한: ",
     "zytsCont":"보안답변과 인증코드를 공개하지 마시고, 보안질문을 기억해두시면 비밀번호를 복구하는데 도움이 됩니다.",
     "qsrxmm":"새 비밀번호를 입력하세요",
     "sydqmmcz":"현재 비밀번호로 재설정",
     "zhmm":"비밀번호 검색에 대한 보안 문제",
     "ysz":"설정되었습니다",
     "tg":"무시하다",
     "qsrdlmm":"비밀번호를 입력하세요",
     "bzxz":"선택하다: ",
     "zwsj":"데이터 없음",
     "qd":"좋아요",
     "zsgd":"자세히보기",
     "zdss":"최소 로트 크기",
     "mnjy":"데모 계정",
     "sx":"필터링",
   },
   "zb":{
     "tgdd":"AI 관리 주문",
     "tgz":"구금 중",
     "ysh":"상환됨",
     "shz":"상환",
     "zq":"주기: ",
     "tian":"낮",
     "syl2":"수익률: ",
     "rgjg":"구독 가격: ",
     "rgjg2":"구독 가격",
     "xdsj":"주문 시간: ",
     "yhl":"이익: ",
     "syts":"남은 일수: ",
     "sh":"구원",
     "syl":"수익률",
     "bz":"이름",
     "dl":"환율",
     "tgts":"개최일: ",
     "tgsl":"호스팅 수량",
     "qsrtgsl":"호스팅 수량을 입력하세요",
     "dbxe":"단일 거래 한도",
     "ljtg":"지금 호스트하세요",
     "zztg":"보관된 자금",
     "yjjrsy":"오늘 예상 수입",
     "ljsy":"누적 수입",
     "tgzdd":"구금 명령",
     "ljzc":"지금 환승",
     "gz":"규칙",
     "cpzq":"제품주기",
     "gm":"구입하다",
     "ts":"중요한",
     "shts":"환매 운영 중이며, 만기 전에 환매할 경우 5% 손실을 입게 됩니다. 사용하시겠습니까?",
     "xgcs":"구매 제한 횟수",
   },
   "dk":{
     "dk":"대출",
     "dkzh":"대출계좌",
     "yzsf":"본인인증하고 더 많은 대출금액 받아가세요!",
     "ksyz":"인증 시작",
     "wxj":"빌리고싶다...",
     "dkqx":"대출 기간(일): ",
     "mrll":"일일 이자율: ",
     "lxze":"총 이자: ",
     "dkts":"3일 동안 대출금에 이자가 필요하지 않으며, 그 이후에는 이자를 지불할 수 있습니다.",
     "xzj":"지금 대출",
     "wyydbzx":"동의하다",
     "dkfwxy":"<대출 서비스 계약>",
     "dkfwxy2":"대출 서비스 계약",
     "dkysxy":"대출 개인정보 보호 계약",
     "dkjl":"대출 내역",
     "hth":"아니요.",
     "yfk":"지급됨",
     "lx":"관심: ",
     "zhke":"총 상환액: ",
     "znj":"연체료: ",
     "znjl":"연체료율: ",
     "yqts":"연체 일수: ",
     "qhk":"상환하다",
     "tpsc":"신용대출(이미지 업로드)",
     "fwxx":"주택정보",
     "srzm":"소득 증명(고용 관계)",
     "yhmx":"은행 계좌 정보",
     "zjz":"증명사진",
     "ljdk":"지금 대출",
     "xm":"이름",
     "ndxm":"당신의 이름",
     "qsrndxm":"당신의 이름을 입력",
     "gj":"국가",
     "ndgj":"귀하의 국가",
     "qsrndgj":"국가를 입력하세요",
     "dz":"주소",
     "nddz":"주소",
     "qsrnddz":"주소를 입력하세요",
     "csrq":"생일",
     "ndcsrq":"귀하의 생년월일",
     "qsrndcsrq":"생년월일을 입력하세요",
     "dhhm":"전화 번호",
     "nddhhm":"전화 번호",
     "qsrnddhhm":"전화번호를 입력하세요",
     "zj":"서류",
     "sfzm":"긍정적인 정체성",
     "qscsfzm":"당신의 정체성의 긍정적인 면을 업로드하세요",
     "sffm":"정체성의 반대",
     "qscsffm":"신분증 뒷면을 업로드하세요.",
     "ddqr":"주문 확인",
     "jk":"대출: ",
     "dkqx2":"대출 기간: ",
     "qrxd":"주문 확인",
     "yhkxq":"상환 기한 내역",
     "hkqr":"상환확인",
     "yhk":"상환 기한: ",
     "jksj":"대출 시간: ",
     "ljhk":"즉시 갚으세요",
   },
   "jy":{
     "rq":"날짜",
     "qqjy":"옵션 기록",
     "hyjy":"계약",
     "qqhy":"옵션",
     "dqwt":"보류 중",
     'wtz':"위탁 중",
     "hyjl":"계약기록",
     "shou":"많이",
     "dk":"영형: ",
     "zhjg":"최신: ",
     "jyfy":"거래 수수료: ",
     "kfsj":"개관 시간: ",
     "gg":"지렛대: ",
     "pl":"일괄: ",
     "kpj":"개장 가격: ",
     "yk":"이익과 손실: ",
     "cd":"주문 취소",
     "jsj":"결제 가격: ",
     "fx":"방향: ",
     "jgsj":"배달 시간: ",
     "gb":"닫다",
     "jxxd":"계속하다",
     "xj":"한계: ",
     "gm":"구입하다: ",
     "sl":"수량",
     "fy":"비용: ",
     "tzbzj":"여백 조정",
     "zyzs":"이익을 얻고 손실을 막으세요",
     "pc":"포지션 마감",
     "mr":"구입하다",
     "zjbzj":"마진 증가",
     "jsbzj":"마진 감소",
     "yxhy":"계약 거래: ",
     "cc":"직위: ",
     "cc2":"위치",
     "cwbzk":"포지션 마진: ",
     "zdzjbzj":"마진 최대 증가: ",
     "zjbzj2":"마진 증가: ",
     "qsrzbzj":"보증금을 입력해 주세요",
     "yxhy2":"빈번한",
     "kp":"평평할 수 있다",
     "zhang":"열려 있는",
     "xj2":"한계",
     "zy":"이익을 얻으세요",
     "zs":"손실 중지",
     "ssjyzl":"거래 유형 검색",
     "ddb":"주문서",
     "di":"엘: ",
     "gao":"시간: ",
     "gb2":"씨: ",
     "fz":"분",
     "mai":"구입: ",
     "zhang2":"증가",
     "tie":"떨어지다",
     "sy":"반품",
     "kz":"강세",
     "kt":"약세",
     "bndy":"다음보다 낮을 수 없습니다.",
     "sxbzj":"필수 보증금: ",
     "ky":"사용 가능: ",
     "sj":"시장",
     "mc":"팔다",
     "zxtzsl":"최소 수량",
     "min":"최소 금액",
     "max":"최대 금액",
     "yebz":"잔액 불충분",
     "ddz":"대기 중",
     "wtzl":"커미션 금액: ",
     "wtjg":"수수료 가격: ",
     "ycd":"취소 된",
     "lswt":"역사적인",
     "qsrzyjg":"이익 실현 가격을 입력하세요.",
     "qsrzsjg":"손실정지가격을 입력해주세요",
     "ccsl":"직책 수: ",
     "ccjg":"포지션 가격: ",
     "ggbs":"여러 가지 활용: ",
     "zy2":"이익을 얻으세요: ",
     "zs2":"손실 중지: ",
     "zje":"일시불: ",
     "ss":"많이: ",
     "kcjg":"개장 가격: ",
     "bzjl":"마진율: ",
     "lscc":"역사적 위치",
     "gmj":"구매 가격: ",
     "guadan":"대기 중인 주문",
     "dqjg":"현재 가격: ",
     "gdjg":"보류 중인 주문 가격: ",
     "pcjg":"종가: ",
     "ccsj":"위치 유지 시간: ",
     "gdsj":"주문 보류 시간: ",
     "pcsj":"마감 시간: ",
     "fdjyk":"변동순이익 및 손실",
     "pcsl":"마감 수량",
     "qrpc":"포지션 청산 확인",
     "ypc":"포지션 폐쇄",
     "ss2":"많이",
     "qsrss":"로트 크기를 입력하세요",
   },
   "gjrz":{
     "sfyz":"KYC 인증",
     "t1":"1. 8M보다 작은 JPG, JPEG 또는 PNG 형식의 사진을 지원합니다.",
     "t2":"2. 증명사진은 선명해야 하며, 수정이나 차단이 불가합니다. 초상화, 신분증 번호, 이름이 선명하게 보여야 합니다.",
     "t3":"3. 사진은 모자를 쓰지 않은 채 촬영되어야 하며, 화장을 하지 않는 것이 좋습니다. 문서를 들고 있는 사람의 얼굴 생김새가 선명하게 보여야 하며, 팔 전체가 노출되어야 합니다.",
     "t4":"좋아요",
     "bh":"거부하다",
     "shz":"검토중",
     "shtg":"시험 합격",
     "nyrzcg":"성공적으로 인증되었습니다",
     "sczjz":"신분증 사진 업로드",
     "sczjzmz":"신분증의 앞면 사진을 업로드하세요.",
     "sczjbmz":"신분증 뒷면 사진 업로드",
     "scgrqmz":"손에 들고 있는 신분증 사진을 업로드하세요.",
     "gjlb":"국가 목록",
     "qxzgjlb":"국가/지역을 선택하세요",
     "zsxm":"실명",
     "qsrzsxm":"실명을 입력하세요",
     "zjlx":"인증서 유형: ",
     "zjhm":"ID 번호",
     "qsrzjhm":"귀하의 ID 번호를 입력하세요",
     "khh":"계좌 개설 은행",
     "qsrkhh":"계좌 개설 은행을 입력하세요",
     "yhkh":"은행 카드 번호",
     "qsryhkh":"은행 카드 번호를 입력하세요",
   },
   "status":{
     "statusText":['실패','검토중','성공'],
   },
   "download":{
     "t1":"언제 어디서나 모바일 트레이딩",
     "xz":"다운로드",
   },
   "langNew":{
     "cxsqsh": "재사용 신청",
     "jxtg": "호스팅 계속",
     "szhb": "암호화폐",
     "gjs": "금속",
     "ny": "에너지",
     "yy": "조잡한",
     "jy": "거래",
     "jmhb": "암호화폐",
     "yxhy": "영구 계약",
     "gdjy": "미결 주문",
     "khh": "계좌 개설",
     "qsrkhh": "은행에 들어가주세요",
     "yhkh": "은행 계좌",
     "qsryhkh": "은행 계좌 번호를 입력해 주십시오",
     "mnzh":"데모 계정",
     "zjjypt":"최고의 거래 플랫폼",
     "brjmzndxq":"이 소프트웨어는 최고의 기술 전문성으로 귀하의 모든 요구를 충족시킵니다.",
     "jx":"계속하다",
     "yssm":"개인 정보 보호 정책",
     "fxqzc":"자금세탁 방지 정책",
     "jgxkz":"규제 라이센스",
     "ckgd":"더",
     "gd":"더",
     "dd":"주문하다",
     "ckdd":"주문 보기",
     "yxdd":"빈번한",
     "qqdd":"옵션",
     "hand":"난 많이= ",
     "lxwm":"문의하기",
     "tpfzl":"여기에 이미지를 배치하거나 ",
     "liulang":"검색",
     "zctpgs":"지원: JPG, JPEG2000, PNG",
     "ysr":"월 소득",
     "ndysr":"월 소득",
     "qsrndysr":"월 소득을 입력하세요.",
     "yqtzje":"투자예정금액",
     "qsrtzje":"예상 투자 금액을 입력하세요.",
     "zszh":"실계좌",
     "qdl": "로그인 해주세요",
     "zx": "즐겨찾기",
     "hkdz":"상환 주소",
     "dkje":"대출 금액: ",
     "zlx":"총이자: ",
     "hkze":"총상환: ",
     "qcz":"입금하러가기",
     "yebz":"잔액이 부족합니다. 충전해주세요.",
     "dhje":"상환할 금액：",
     "hkjl":"상환명령：",
     "hkje":"반환：",
     "kyye":"균형：",
     "qb": '모두',
     "lmc": "체인명：",
     "search": "찾다",
     "mrjg":"가격",
     "lxkf":"연락하다",
     "wyj":"손해금",
     "yxsj":"진행 중：",
     "jssj":"마치다：",
     "hksj":"반환：",
     "sysj":"남은 시간：",
     "jkqx":"남은 시간：",
     "yq":"연체：",
     "qqss":"귀하의 옵션 거래 주문이 만료되었으며 귀하의 손실은 다음과 같습니다",
     "qqlr":"귀하의 옵션 거래 주문이 만료되었으며 귀하의 이익은 다음과 같습니다",
     "bz":"통화",
     "dzje":"받은 금액",
     "lxyxzc":"이메일 지원",

     "mnzh": "데모 계정",
         "zszh": "실제 계정",
         "qsrgjc": "키워드를 입력하세요",
         "wh": "외환",
         "szhb": "디지털 통화",
         "js": "금속",
         "ny": "에너지",
         "sj": "시장 가격",
         "gd": "보류 중인 주문",
         "mr": "구매",
         "mc": "매도",
         "ss": "로트 크기",
         "qsrss": "로트 크기를 입력하세요",
         "zy": "이익실현",
         "zs": "손절매",
         "qsrzyj": "이익 실현 가격을 입력하세요",
         "qsrzsj": "손절매 가격을 입력하세요",
         "xfbzj": "필요한 여백:",
         "kyye": "사용 가능한 잔액:",
         "cc": "위치",
         "ypc": "청산 포지션",
         "name": "이름",
         "ddh": "주문 번호",
         "mmfx": "매수 및 매도 방향",
         "gmfs": "구매 방법",
         "xdj": "주문 가격",
         "sxf": "서비스 수수료",
         "sxf2": "취급 수수료:",
         "cz": "작업",
         "pc": "청산 포지션",
         "cx": "취소",
         "pccg": "종료 성공",
         "dl": "로그인",
         "yxhzhdl": "이메일 및 계정 로그인",
         "qsryxhzh": "이메일 주소나 계정을 입력하세요",
         "mm": "비밀번호",
         "qsrmm": "비밀번호를 입력하세요",
         "cjxnzh": "데모 계정 만들기",
         "wjmm": "비밀번호를 잊으 셨나요",
         "myzh": "계정이 없나요?",
         "zc": "등록",
         "wjmm2": "비밀번호 찾기",
         "zh": "계정",
         "qsrzh": "계좌번호를 입력하세요",
         "yzm": "인증 코드",
         "qsryzm": "확인 코드를 입력하세요",
         "hqyzm": "인증 코드 받기",
         "qrmm": "비밀번호 확인",
         "qzcsrmm": "비밀번호를 다시 입력하세요",
         "qd": "확인",
         "yxh": "우편함 번호",
         "qsryxh": "사서함 번호를 입력하세요",
         "sjh": "휴대전화 번호",
         "qsrsjh": "전화번호를 입력하세요",
         "xm": "이름",
         "qsrxm": "이름을 입력하세요",
         "gj": "국적",
         "qxzgj": "국적을 선택하세요",
         "zjlx": "인증서 유형",
         "qxzzjlx": "문서 유형을 선택하세요",
         "zjhm": "문서 번호",
         "qsrzjhm": "ID 번호를 입력하세요",
         "qpsbsczj": "사진을 찍고 신분증을 업로드하세요",
         "pszm": "앞에서 쏴라",
         "psfm": "뒷면을 쏴라",
         "qsczmz": "정면 사진을 올려주세요",
         "qscfmz": "반전 사진을 올려주세요",
         "scqmz": "서명된 사진 들고 있기",
         "qscqmz": "서명된 사진을 업로드하세요",
         "wyyd": "읽고 이해했습니다",
         "yhxy": "사용자 계약",
         "grzx": "개인 센터",
         "gnlb": "함수 목록",
         "smrz": "실명인증",
         "rj": "입금",
         "cj": "철회",
         "zhjl": "계정 기록",
         "xx": "메시지",
         "wdyq": "내 초대장",
         "zhaq": "계정 보안",
         "sz": "설정",
         "lmc": "체인 이름",
         "bcewm": "QR 코드 저장",
         "fzdz": "주소 복사",
         "fzcg": "복사 성공",
         "rjsl": "입금액",
         "qsrsl": "수량을 입력하세요",
         "zdsl": "최소 수량",
         "pzms": "해시 값",
         "qsrpzms": "해시 값을 입력하세요",
         "lkrj": "즉시 입금",
         "cjdz": "출금 주소",
         "qsrcjdz": "출금 주소를 입력하세요",
         "cjsl": "출금 금액",
         "qsrcjsl": "출금 금액을 입력하세요",
         "lkcj": "즉시 출금",
         "ddh2": "주문 번호:",
         "time": "시간:",
         "je": "금액:",
         "zt": "상태:",
         "bt": "제목:",
         "nr": "내용:",
         "sqz": "적용 중",
         "yqhy": "친구 초대",
         "yqhyyqzc": "함께 등록할 친구 초대",
         "wdyqm": "내 초대 코드",
         "wdyqlj": "내 초대 링크",
         "fz": "복사",
         "xgdlmm": "로그인 암호 변경",
         "szjymm": "거래 비밀번호 설정",
         "xgmm": "비밀번호 변경",
         "tgyzmxgmm": "인증 코드를 통해 비밀번호 변경",
         "jmm": "이전 비밀번호",
         "qsrjmm": "이전 비밀번호를 입력하세요",
         "dlmm": "로그인 비밀번호",
         "qsrdlmm": "로그인 비밀번호를 입력하세요",
         "jymm": "거래 비밀번호",
         "qsrjymm": "거래 비밀번호를 입력하세요",
         "mmcd": "비밀번호 길이 6자리",
         "tcdl": "로그아웃",
         "zxkf": "온라인 고객 서비스",
         "bzzx": "도움말 센터",
         "ksrm": "빠른 시작",
         "kcjg": "오픈 포지션 가격",
         "pcjg": "종가",
         "gdjg": "보류 중인 주문 가격",
         "pcfs": "포지션 닫기",
         "hyl": "계약 금액",
         "thbzj": "보증금 환불",
         "gmsl": "구매 수량",
         "sysl": "남은 수량",
         "sccg": "성공적으로 저장됨",
         "qxdl": "먼저 로그인하세요",
         "sy": "수입",
          "tj": "제출",
          "sfz": "신분증",
          "hz": "여권",
          "jz": "운전면허증",
          "qt": "기타",
          "qxzmnje": "시뮬레이션 금액을 선택하세요",
          "cjmnzhcg": "데모 계정 만들기 성공!",
          "dlmmts": "로그인 비밀번호를 입력하세요",
          "mmts": "비밀번호 길이 6-24자리",
          "jymmts": "비밀번호 길이 6자리",
          "shz": "검토 중",
          "shtg": "승인됨",
          "jj": "거절",
          "xyb": "다음",
          "emailgsts": "입력한 이메일 주소가 규칙에 맞지 않습니다",
          "telgsts": "입력한 휴대폰 번호의 형식이 올바르지 않습니다.",
          "lcmmbyz": "입력한 두 개의 비밀번호가 일치하지 않습니다.",
          "gdj": "보류 주문 가격",
          "lx": "유형",
          "qsrgdj": "예약 주문 가격을 입력하세요",
          "kccg": "포지션 열기 성공!",
          "pcsl": "마감 수량",
          "mnts": "가상 계정이 만료되었습니다. 다시 생성하십시오",
          "wtfa": "위임 체계",
          "kcsj": "오픈 포지션 시간",
          "gbsj": "종료 시간",
          "gylx": "교환",
          "hyjy": "계약",
          "zwsj": "아직 데이터 없음",
          "zwkf": "이 충전 채널은 아직 열리지 않았습니다.",
   },
   "langNew9":{
   "dzje":"거래 상품의 시장 동향",
   "lxyxzc":"디지털 거래 여정을 시작하세요",
   "text1":"계정을 만들어 시작하세요",
   "text2":"친구를 초대하여 MFTG에 가입하고 함께 플레이하세요",
   "text3":"계정에 충전하세요",
   "text4":"여러 통화 충전을 지원하여 빠르게 거래를 시작할 수 있습니다",
   "text5":"거래를 시작하세요",
   "text6":"다양한 고품질 거래 쌍을 제공하고 MFTG에서 즐겁게 거래하세요",
    "text7":"친구를 초대하여 USDT를 획득하세요",
    "text8":"친구를 초대하여 쉽게 USDT를 획득하세요",
    "text9":"대출 기능이 온라인 상태입니다",
    "text10":"돈이 없을 때 대출을 신청할 수 있으며, 대출은 빠르면 당일에 발급됩니다",
   "text11":"모든 자산 거래",
   "text12":"외환, 암호화폐, 선물, ETF 등",
   },
   "bank":{
     "text1":"가장 신뢰할 수 있는 재무 관리 플랫폼",
     "text2":"실시간 뉴스 알림",
     "text3":"금융산업에 대한 실시간 정보를 이해하세요.",
     "text4":"이해하기 시작하다",
     "text5":"뉴스 플래시",
     "text6":"은행 선택",
     "text7":"은행 카드",
     "text8":"양...",
     "text9":"은행 카드 추가",
     "text10":"은행 계좌",
     "text11":"은행계좌를 입력해주세요",
     "text12":"카드 아이디",
     "text13":"카드번호 아이디를 입력해주세요",
     "text14":"은행 국제 코드",
     "text15":"은행 국제 코드",
     "text16":"전화번호를 입력해주세요",
     "text17":"다음에 추가",
     "text18":"은행 카드 삭제",
     "text19":"실제 도착",
     "text20":"인출 정보",
     "text21":"은행 카드 선택",
     "text22":"참고",
     "text23":"최소 인출 금액:",
     "text24":"최소 인출 금액보다 적은 금액은 인출이 허용되지 않습니다",
     "text25":"• 자금의 안전을 보장하기 위해 계정 보안 정책이 변경되거나 비밀번호가 변경되면 인출을 수동으로 검토합니다. 직원이 전화 또는 이메일로 연락할 때까지 기다려 주십시오.",
     "text26":"• 정보가 변조되거나 유출되는 것을 방지하기 위해 컴퓨터와 브라우저가 안전한지 확인하십시오.",
     "text27":"• 인출하는 USD의 경우, 각 작업은 인출 페이지에 표시된 총 자산 금액이 해당 인출 금액만큼 감소함을 의미합니다. 금액.",
     "text28":"인출 기록",
     "text29":"법정 화폐 유형",
   },
   "kxt": {
       "fs": "time",
       "fz":"min",
       "xs":"hour",
       "tian":"day",
       "zhou":"week",
     },
     "xbsg":{
       "title": "Startup",
       "wdsg": "세부",
       "scts": "잠금 날짜:",
       "sy": "나머지",
       "ljsg": "지금 구독하세요",
       "ysk": "품절",
       "xzjdy": "지금 구독하기",
       "dy": "구독",
       "fxjg": "발행가격",
       "fxl": "순환",
       "ssrq": "상장 날짜",
       "yxqx": "만료 날짜",
       "qsrsl": "수량을 입력하세요",
       "syl": "남은 금액",
       "sgrq": "구입 날짜",
       "sgsl": "구매 수량",
       "bz": "통화",
       "yebz": "USDT 잔액 부족",
       "tgsl": "수량 통과",
       "shz": "검토 중",
       "wtg": "실패",
       "ytg": "통과",
       "ffsb": "발급 실패",
       "yth": "환불됨",
       "sbly": "실패 이유",
       "jjly": "거절 이유",
       "bz2": "통화:",
       "fxjg2": "발행 가격:",
       "sgsl2": "구매 수량:",
       "tgsl2": "합격 수량:",
       "sssj": "출시 시간",
       "sssj2": "출시 시간:",
       "sgj": "구독 가격",
       "sgj2": "구매 가격:",
       "sgsj": "구매 시간",
       "sgsj2": "구매 시간:",
       "sbly2": "실패 이유:",
       "jjly2": "거절 이유:",
       "bzj": "여백:",
       "zsxf": "총 거래 수수료:",
       "djze": "고정된 총 금액:",
       "djje": "동결 양"
       },
       "bzhl": {
         "title": "피제수",
         "gz": "규칙",
         "tgdd": "에스크로 주문",
         "zztgdzj": "보호 예수 자금",
         "yjjrsy": "오늘의 수입",
         "ljsy": "총 수입",
         "tgzdd": "보호 예수 주문",
         "cljxcp": "전략적 광고 상품",
         "dbxe": "단일 한도",
         "rsyl": "일일 수익률",
         "zq": "주기",
         "qmr": "지금 매입",
         "bbzhzc": "계좌 자산",
         "dd": "주문",
         "buy": "매입",
         "jxcp": "주요 상품",
         "ckdd": "주문 확인",
         "gd": "더 보기",
         "xzbzts": "간단하고 안전합니다. 배당금은 여러 통화로 선택할 수 있습니다.",
         "qtbz": "기타 동전",
         "zrsy": "어제 수입",
         "zdisyl": "최소 수율",
         "zdasyl": "최대 수율",
         "day": "일",

         title1: 'AI량화',
         ttzbt: '天天赚不停',
         wdtg: '내 호스팅',
         zztgdzj: '보호 예수 자금',
         yjjrsy: '매일 추정',
         ljsy: '총 수입',
         tgzdd: '보호 예수 주문',
         tgdd: '에스크로 주문',
         t1: '위험이 적고 안정적인 재무 관리, 필요한 경우 언제든지 상환 가능',
         t2: '무료 자금 관리 도우미',
         cljxcp: '상품 주기',
         dbxe: '단일 한도',
         rsyl: '일일 수익률(%)',
         rsyl2: '일일 수익률：',
         zq: '주기',
         qmr: '구매하기',
         ckgd: 'xem thêm',
         cpgk: '제품 개요',
         pxsj: '배당금 지급 시기',
         tgzj: '보호 예수 자본',
         tqsh: '조기 상환',
         cpld: '상품 하이라이트',
         cpgz: '제품 규칙',
         cont: '브릭 이동은 플랫폼에서 USDT를 호스팅하는 것이며, 플랫폼의 전문 팀은 브릭을 이동할 권리가 있습니다. 참가자는 언제든지 액세스 할 수있는 펀드 보관 기간 동안 브릭 이동 수입에서 플랫폼의 몫을 얻을 수 있습니다. 안전하고 편리합니다.',
         zj: '100% 펀딩',
         aqbz: '보안',
         jjrsy: '공휴일 수입',
         bjd: '무중단',
         cgcrh: '성공적인 예치 후',
         dtqx: '오늘의 이자 가치',
         ljzr: '지금 전송',
         xqglgj: '무료 자금 관리 도구',
         ddh: '주문 번호',
         tgje: '보호 예수 금액',
         tgsj: '주기 일',
         yhl: '수익:',
         xdsj: '주문 시간',
         zt: '상태',
         fh: '반환',
         qrnhsy: '七日年化收益',
         ygy: '1个月',
         bn: '半年',
         yn: '1年',
         yuan: '元',
         tzfx: '투자 위험',
         shsc: '교환 시간',
         di: '로우',
         yggzr: '1 일',
         msgsxf: '무료 구독료',
         mr: '매일',
         dqfh: '기한 만료 시 반환',
         ljgm: '지금 매입',
         tgz: '보호 예수 중',
         sh: '상환',
         ywc: '완료됨',
         ysh: '상환됨',
         all: '전체',
         "xzbzts": "간단하고 안전합니다. 배당금은 여러 통화로 선택할 수 있습니다.",
         "qtbz": "기타 동전"
       },
       "bzhlgm": {
         "qtzq": "USDT 7일 주기",
         "rsyl": "일일 수익률",
         "lczq": "재무적 주기",
         "dbxe": "단일 한도",
         "pxsj": "배당금 지급 시기",
         "mr": "매일",
         "dqfh": "기한 만료 시 반환",
         "tgzj": "보호 예수 자본",
         "tqsh": "조기 상환",
         "yjsy": "예상 수입(USDT)",
         "kyzc": "이용 가능 자산(USDT)",
         "cpjs": "상품 소개",
         "tgje": "보호 예수 금액",
         "qsrtgje": "보호 예수 금액을 입력해 주십시오",
         "qb": "전체",
         "rm": "지금 매입",
         "cpzq": "상품 주기",
         "gz": "규칙과 이자를 알아 두기",
         "ktgje": "예탁 가능 금액: ",
       },
       "bzhlwdtg": {
         "title": "주문 상태",
         "tgz": "보호 예수 중",
         "ywc": "완료됨",
         "ysh": "상환됨",
         "tgje": "보호 예수 금액/보호 예수 시간",
         "rsyl": "일일 수익률",
         "yhl": "수익:",
         "xdsj": "주문 시간",
         "sh": "상환",
         "ddxq": "주문 상세 정보",
         "ddh": "주문 번호"
       },
       "bzjj": {
         "t1": "날마다 수익을 올리세요",
         "cpld": "상품 하이라이트",
         "scsq": "언제라도 예치하고 받으세요",
         "pxzq": "배당금 주기",
         "mtxf": "매일 배분",
         "hqlx": "현재 이자",
         "zj": "100% 펀딩",
         "aqbz": "보안",
         "jjrsy": "공휴일 수입",
         "sybjd": "지속적인 이익",
         "bjd": "무중단",
         "cgcrh": "성공적인 예치 후",
         "dtqx": "오늘의 이자 가치",
         "jglz": "예",
         "syjs": "총 수입 계산",
         "cont2": "최소: 10000U x 0.3%=30U",
         "cont3": "최대: 10000U x 0.5%=50U",
         "gywyj": "확정손해 배상액 안내",
         "wycy": "가입하고 싶습니다"
       },
       "wydb": {
         "title": "대출을 원합니다",
         "db": "통화",
         "dbz": "통화",
         "jl": "기록",
         "jdzq": "대출 기간(일)",
         "qhk": "갚으러 가기",
         "ljdb": "누적 대출 통화(usdt)",
         "dhkbs": "보류 중인 상환액",
         "jkje": "대출 금액(usdt)",
         "qsrje": "금액을 입력하세요",
         "rll": "일일 요금",
         "hkfs": "상환 방법",
         "dqych": "만기일에 원금과 이자를 갚으세요",
         "lx": "흥미",
         "fkjg": "대출 기관",
         "tpsc": "신용 대출(사진 업로드)",
         "fwxx": "집 정보",
         "srzm": "소득 증명",
         "yhmx": "은행 세부정보",
         "qscfwxx": "주택 정보를 업로드하세요",
         "qscsrzm": "소득 증명을 업로드하세요",
         "qscyhmx": "은행 정보를 업로드하세요",
         "qsczjz": "신분증 사진을 올려주세요",
         "zzjz": "증명 사진",
         "yd": "읽고 동의합니다",
         "xy": "응용 대출 계약",
         "sqdb": "대출을 신청하려면 클릭하세요",
         "gb": "닫기",
         "qd": "확인",
         "ts": "신청서 대출 동의서를 확인해주세요",
         "dbjl": "대출 기록",
         "hkhth": "대출 계약 번호",
         "wsh": "미검토",
         "yfk": "지급됨",
         "sqrq": "신청 날짜",
         "zq": "마침표",
         "dbsl": "대출 금액",
         "zhke": "총 상환 금액",
         "yhkxq": "상환 세부 정보",
         "bqyhk": "이 기간 내 상환 기한(USDT)",
         "hktips": "잔액이 충분한지 확인하세요. 잔액이 부족하면 상환하기 전에 충전하세요.",
         "bj": "교장선생님",
         "jie": "빌리다",
         "ljhk": "즉시 상환",
         "qcz": "충전하러 가기",
         "yebzqxcz": "잔고가 부족합니다. 상환하기 전에 충전하세요.",
         "znj": "연체료",
         "yqts": "지난 일수",
         "kjdje": "대출 가능 금액",
         "rlxl": "일일 이자율",
         "rlxl2": "일일 이자율:",
         "yqll": "지연 이자율",
         "yqll2": "연체된 이자율:",
         "ljlx": "누적된 이자",
         "zrlx": "어제의 관심사",
         "jddd": "대출 주문",
         "zxje": "최소 금액:",
         "jexz": "한도 금액:",
         "xypztp": "자격증명 이미지:",
         "hkpztp": "상환 바우처 사진:",
         "ysxsl": "적립된 이자 금액:",
         "ysxts": "이자가 발생한 일수:",
         "jdsl": "대출 금액:",
         "fkjg2": "대출 기관:",
         "zq2": "기간:",
         "sqrq2": "신청 날짜:",
         "zhke2": "총 상환 금액:",
         "yff": "발급됨",
         "hkz": "상환",
         "yjq": "지워짐",
         "jjdk": "대출 거부",
         "ch": "철회",
         "cxsq": "다시 적용",
         "cgkdkxz": "대출 한도 초과",
         "hdgz": "이벤트 규칙"
       },
       "xyf": {
         "title": "신용 점수",
         "dqxyf": "현재 신용 점수",
         "hwqxyf": "학점을 얻지 못했습니다",
         "zwxyf": "아직 신용 점수가 없음",
         "pgsj": "평가 시간",
         "xypz": "자격 증명(이미지 업로드)",
         "cxtjsh": "검토를 위해 다시 제출",
         "tjsh": "검토를 위해 제출",
         "yjj": "거부됨",
         "hq": "가져오기",
         "qx": "취소",
         "qxwcsmrz": "먼저 실명 인증 완료"
       },
       "hkxq":{
         "dd": "주문",
         "fzhkdz": "상환 주소 복사",
         "hkxq": "상환 세부 정보",
         "zlx": "총 이자",
         "zhk": "총 상환액",
         "hkjg": "상환 대행사",
         "qschkpz": "상환 바우처를 업로드하세요",
         "hkpz": "상환 바우처",
         "lxkfhk": "환불을 위해 고객 서비스에 문의하십시오."
       },
       "tipsNew":{
         "wjmmts": "인증 코드로 비밀번호 복구",
         "qscpztp": "바우처 이미지 업로드",
         "emailgsts": "유효한 이메일을 입력하십시오",
         "telgsts": "휴대폰 번호가 잘못되었습니다",
         "lcmmbyz": "비밀번호를 확인해주세요",
         "zdsl": "최소 금액 ",
         "sldydy": "다음보다 크거나 같은 수량",
         "zxtzsl": "최소 투자 금액 ",
         "ddz": "기다리는",
         "xs": "시간",
         "min": "최소 금액 ",
         "max": "최대 금액 ",
         "yebz": "잔액 불충분",
         "qsrss": "로트를 입력하세요",
         "zdss": "최소 부지",
         "yjj": "거부",
         "shz": "구원"
       },
       "status":{
         "statusText": ['실패','처리 대기 중','성공'],
       },
       "jghy": {
         "jghy": "스왑",
         "yxhy": "영구 계약",
         "mz": "강세",
         "md": "약세",
         "gmj": "구매가",
         "jsj": "정산가",
         "xj": "현재 가격",
         "fx": "방향",
         "sl": "금액",
         "jgsj": "배송 시간",
         "gb": "클로즈",
         "jxxd": "계속 주문",
         "cclb": "주문 목록",
         "zc": "현재",
         "lscc": "이력",
         "qblx": "모든 유형",
         "yk": "수익 및 손실",
         "ddqr": "주문 확인",
         "dqsj": "만료 시간",
         "jssj": "배송 시간",
         "sy": "수익",
         "tzje": "투자 금액",
         "zdje": "최저 가격 0",
         "kyye": "사용 가능",
         "sxf": "취급 수수료",
         "sxfl": "수수료율",
         "jypz": "쌍",
         "jyfx": "방향",
         "qrxd": "확인",
         "dqye": "현재 잔고",
         "zt": "상태"
       },
       "bbjy":{
        "cjsj":"수수료 가격",
        "wtjg":"거래 가격",
        "cjjg":"거래 없음",
        "wcj":"거래 완료",
        "ycj":"취소",
        "yqx":"취소",
        "qxwt":"取消委托",
        "qsrxj":"제한 가격을 입력하세요."
      }
   // "langNew2":{
   //   "sy":"홈페이지",
   //   "sc":"시장",
   //   "sclb":"시장 목록",
   //   "jy":"거래",
   //   "zh":"계정",
   //   "db":"대출",
   //   "zchm":"등록 번호",
   //   "cp":"제품",
   //   "tzjd":"투자대출",
   //   "zxzc":"온라인 지원",
   //   "xd":"주문하다",
   //   "zzjptgmnr":"미래에 투자하세요.공정하고 개방적인 금융 시스템에서 포트폴리오를 성장시키세요.",
   //   "yy":"앱",
   //   "pqnr":"기존의 틀에서 벗어나 정밀한 재무관리 도구를 제공하는 모바일뱅킹입니다.",
   //   "jiami":"암호화폐",
   //   "tgnr":"암호화폐를 사용하여 입금하면 추가 보안 계층을 확보하고 빠른 거래 처리를 보장할 수 있습니다.",
   //   "jyl":"24시간 거래량",
   //   "ssjmhb":"암호화폐 목록",
   //   "zchy":"등록 된 사용자들",
   //   "djxz":"다운로드하려면 클릭하세요",
   //   "azsc":"안드로이드 마켓",
   //   "pgsd":"애플 스토어",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/hy.js